window.MQ_CONFIG = {"quizId": "everbright-melina-v1", "product": "everbright", "resultPageUrl": "https://joinmelina.com/pages/everbright-quiz", "offerVersion": "sub39-try59-2026-07", "klaviyoPublicKey": "XzDWXH", "klaviyoListId": "VFu6qs", "shopifyVariantId": "43739752235062", "cartPermalinkTemplate": "https://clubeverbright.com/cart/{variant_id}:{quantity}?attributes[utm_source]=quiz&attributes[utm_medium]=result-page&attributes[utm_campaign]={quiz_id}&attributes[utm_content]={variant}-{modifiers}&attributes[eb_phase]={phase_code}&attributes[eb_sig]={signature_codes}&attributes[eb_dose]={dose_code}&attributes[eb_age]={age_band}", "resultTokenKeyHex": "d2d894fe152d9e0e54f2cf8c9ad91efcc6883cbf63a477f2fc056788429c542c", "exitUrl": "", "questionIds": ["age", "symptoms", "goal", "cycle", "energy", "tried", "duration"], "archetypeNames": {}, "archetypeExplainer": {}, "patternStat": {}, "variantPitch": {"ES": "Your reading places you in early perimenopause — the foundational layer most women wish they'd started 5 years earlier.", "DS": "Your reading places you in mid-perimenopause — the active dose, calibrated to where you are.", "PT": "Your reading places you in the menopause shift — the active dose, calibrated to where you are.", "PR": "Your reading places you in postpartum recovery — the active dose, calibrated to the metabolic cost pregnancy left behind.", "ST": "Your reading places you in the pre-shift years — the foundational layer that compounds the longest."}, "questions": [{"id": "age", "options": [{"value": "u40", "label": "Under 40"}, {"value": "40_49", "label": "40–49"}, {"value": "50_59", "label": "50–59"}, {"value": "60p", "label": "60+"}]}, {"id": "symptoms", "options": [{"value": "fatigue", "label": "Moderate-to-intense fatigue"}, {"value": "fog", "label": "Brain fog"}, {"value": "concentrate", "label": "Difficulty concentrating"}, {"value": "motivation", "label": "Low motivation"}, {"value": "crash", "label": "Afternoon energy crashes"}, {"value": "sleep", "label": "Waking up tired / restless sleep"}, {"value": "skin", "label": "Skin looking duller or older"}, {"value": "mood", "label": "Mood more up-and-down"}, {"value": "recovery", "label": "Slower recovery from workouts, more aches"}, {"value": "none", "label": "None of these"}]}, {"id": "goal", "options": [{"value": "energy", "label": "Steady, all-day energy"}, {"value": "focus", "label": "Sharp focus & memory"}, {"value": "glow", "label": "Glowing, healthier skin"}, {"value": "recovery", "label": "Faster physical recovery"}, {"value": "all", "label": "Longevity & healthy aging"}]}, {"id": "cycle", "options": [{"value": "regular", "label": "I still have a regular cycle"}, {"value": "postpartum", "label": "I'm postpartum"}, {"value": "peri", "label": "I think I am in perimenopause"}, {"value": "meno", "label": "I am in menopause"}, {"value": "postmeno", "label": "I am postmenopause"}, {"value": "prefer_not", "label": "I prefer not to say"}]}, {"id": "energy", "options": [{"value": "pm", "label": "Crashes hard in the afternoon"}, {"value": "am", "label": "Low from the morning on"}, {"value": "swing", "label": "Up and down"}, {"value": "steady", "label": "Pretty steady — I want to protect it"}]}, {"id": "tried", "options": [{"value": "hrt", "label": "HRT (hormone therapy)"}, {"value": "nad", "label": "NAD+ / longevity supplements"}, {"value": "adaptogens", "label": "Adaptogens / other supplements"}, {"value": "collagen", "label": "Collagen or skin supplements"}, {"value": "greens", "label": "Greens / multivitamins"}, {"value": "diet", "label": "Diet & exercise"}, {"value": "caffeine", "label": "Caffeine to push through"}, {"value": "nothing", "label": "Nothing yet"}]}, {"id": "duration", "options": [{"value": "recent", "label": "Just recently"}, {"value": "6_12", "label": "6–12 months"}, {"value": "year", "label": "A year or more"}, {"value": "always", "label": "As long as I can remember"}, {"value": "proactive", "label": "I don't feel off — I want to stay ahead of midlife changes"}]}], "phaseDisplayName": {"ST": "Pre-Shift Years", "ES": "Early Perimenopause", "DS": "Mid Perimenopause", "PT": "Menopause & Beyond", "PR": "Postpartum Recovery"}, "phaseExplainer": {"ST": "You're earlier in this conversation than most. The cellular cost of hormone\nshifts begins quietly around 30 — before any cycle change, before any doctor\nwill name it. Starting now is what most women wish they'd done.", "ES": "Your cycle is starting to change — length, flow, PMS — and the brain and\nenergy shifts often started before that, getting blamed on stress or sleep.\nMost women in this window aren't told what's actually happening for another\n2–3 years.", "DS": "You're in the part of the arc where things start to compound — and where\nmost women finally Google what's going on. The good news: this is also\nwhere the right protocol moves the needle fastest.", "PT": "Estrogen has made its big drop — and the cellular cost it leaves keeps\ncompounding, often quietly. Most women don't realize how much of what\nthey call \"aging\" is actually the long tail of the hormone shift.", "PR": "Pregnancy is the most metabolically expensive thing a body can do — and\nthe cellular cost often doesn't fully recover on its own. What you're\ndescribing isn't \"mom brain\" or \"just life now.\" It's a recoverable shift."}, "phaseInterstitialBody": {"ST": "Your reading so far: pre-shift — the window where starting compounds the longest.", "ES": "Your reading so far: the early-shift pattern — the one most women aren't told about for another 2–3 years.", "DS": "Your reading so far: mid-shift — where it compounds, and where the right protocol moves fastest.", "PT": "Your reading so far: past the shift — the sharp drops are behind you, but the cellular drain is still running.", "PR": "Your reading so far: postpartum recovery — a real, measurable cost. And a recoverable one."}, "signatureDisplayName": {"BR": "Brain", "EN": "Energy", "RC": "Recovery", "GL": "Glow"}, "signatureReceiptLine": {"BR": "Your morning brain — words harder to find than they used to be.", "EN": "Your afternoon energy — coffee isn't covering it anymore.", "RC": "Your recovery — slower than the version of you you remember.", "GL": "Your skin and the way you look in the mirror — not what it used to be."}, "signatureLeadIngredientH3": {"BR": "Why citicoline matters most for you", "EN": "Why nicotinamide riboside matters most for you", "RC": "Why pterostilbene matters most for you", "GL": "Why grape seed and astaxanthin matter most for you"}, "signatureLeadIngredientBody": {"BR": "200 mg of citicoline supports the neurotransmitter pool your brain uses\nfor recall, focus, and word-finding. Most NAD+ supplements skip this\nentirely — for a brain-forward reading, it's the layer that closes the\nloop. It's also the fastest-acting layer in the formula.", "EN": "300 mg of NR is the cellular fuel your mitochondria depend on —\nthe molecule midlife burns off fastest, and the one your afternoons\nare asking for. Not another buzz; the molecule that means you\ndon't need one.", "RC": "Pterostilbene crosses cell membranes 4× more efficiently than resveratrol\n— reaching the muscle and connective-tissue mitochondria where training\nand stress recovery live. For active women after the hormone shift, it's\nthe recovery-specific moat.", "GL": "These two antioxidants replace the cellular protection estradiol\nused to carry — vascular elasticity, photoprotection, and the\nmicrocirculation that gives skin its shine. No generic NAD+ supplement\naddresses this; it's the missing piece for women after the hormone shift."}, "receiptMirrors": {"symptoms": {"fatigue": "Your energy — fatigue that rest isn't fixing.", "fog": "Your brain — foggier than the version of you you remember.", "concentrate": "Your focus — harder to hold than it used to be.", "motivation": "Your drive — the want-to is harder to find.", "crash": "Your afternoons — crashing where you used to cruise.", "sleep": "Your mornings — waking up tired, sleep not restoring.", "skin": "Your skin — duller, not responding like it used to.", "mood": "Your mood — more up-and-down than it should be.", "recovery": "Your recovery — slower from workouts or anything physical.", "none": ""}, "energy": {"pm": "Your afternoon energy — crashing hard, needing a nap or coffee.", "am": "Your energy — low from the morning on.", "swing": "Your energy — up and down through the day.", "steady": ""}, "duration": {"recent": "for a few months now — early in the curve.", "6_12": "for 6–12 months — long enough to know it isn't a phase.", "year": "for a year or more — long enough that nothing is fixing itself.", "always": "for as long as you can remember — and it still isn't 'just you'.", "proactive": ""}}};
/* Mighty Quiz MVP — vanilla JS state machine. */
(function () {
  'use strict';

  const ROOT = document.getElementById('mq-root');
  if (!ROOT) return;
  const CFG = window.MQ_CONFIG || {};

  // ---------- Result-URL token (AES-256-GCM) ----------
  // The result URL is `/pages/mighty-quiz?r=<token>` — never a query string
  // of answer keys. Token format:
  //   base64url( nonce(12) ‖ ciphertext ‖ auth_tag(16) )
  // Plaintext: JSON { s, qid, v, m, a } where `s` is the envelope schema
  // version. Decoder rejects unknown `s` or `qid` and falls through to a
  // fresh quiz start. See docs/2026-05-01-mighty-quiz-url-tokenization.md.
  const TOKEN_SCHEMA_VERSION = 1;
  var _UT_LABELS = { v: 'vestibular', h: 'hormonal', c: 'chronic', t: 'tension' };

  function _hexToBytes(hex) {
    const out = new Uint8Array(hex.length / 2);
    for (let i = 0; i < out.length; i++) out[i] = parseInt(hex.substr(i * 2, 2), 16);
    return out;
  }
  function _bytesToBase64Url(bytes) {
    let s = '';
    for (let i = 0; i < bytes.length; i++) s += String.fromCharCode(bytes[i]);
    return btoa(s).replace(/\+/g, '-').replace(/\//g, '_').replace(/=+$/, '');
  }
  function _base64UrlToBytes(s) {
    s = s.replace(/-/g, '+').replace(/_/g, '/');
    while (s.length % 4) s += '=';
    const bin = atob(s);
    const out = new Uint8Array(bin.length);
    for (let i = 0; i < bin.length; i++) out[i] = bin.charCodeAt(i);
    return out;
  }
  async function _importAesKey() {
    const hex = CFG.resultTokenKeyHex || '';
    if (hex.length !== 64) throw new Error('result_token_key_hex missing or wrong length');
    return await window.crypto.subtle.importKey(
      'raw', _hexToBytes(hex), { name: 'AES-GCM' }, false, ['encrypt', 'decrypt'],
    );
  }
  async function buildResultToken(routing, answers) {
    const payload = {
      s: TOKEN_SCHEMA_VERSION,
      qid: CFG.quizId,
      v: routing.variant,
      m: routing.modifiers || [],
      a: answers || {},
    };
    const key = await _importAesKey();
    const nonce = window.crypto.getRandomValues(new Uint8Array(12));
    const plain = new TextEncoder().encode(JSON.stringify(payload));
    const cipher = new Uint8Array(
      await window.crypto.subtle.encrypt({ name: 'AES-GCM', iv: nonce }, key, plain),
    );
    const out = new Uint8Array(nonce.length + cipher.length);
    out.set(nonce, 0);
    out.set(cipher, nonce.length);
    return _bytesToBase64Url(out);
  }
  async function decodeResultToken(token) {
    try {
      const blob = _base64UrlToBytes(token);
      if (blob.length < 12 + 16) throw new Error('token too short');
      const nonce = blob.slice(0, 12);
      const cipher = blob.slice(12);
      const key = await _importAesKey();
      const plain = new Uint8Array(
        await window.crypto.subtle.decrypt({ name: 'AES-GCM', iv: nonce }, key, cipher),
      );
      const decoded = JSON.parse(new TextDecoder().decode(plain));
      if (decoded.s !== TOKEN_SCHEMA_VERSION) {
        _capture('quiz_token_rejected', { reason: 'schema_version', token_s: decoded.s });
        return null;
      }
      if (decoded.qid !== CFG.quizId) {
        _capture('quiz_token_rejected', { reason: 'quiz_id', token_qid: decoded.qid });
        return null;
      }
      return decoded;
    } catch (e) {
      _capture('quiz_token_rejected', { reason: 'decrypt_fail' });
      return null;
    }
  }

  // ---------- Persistence ----------
  const SS_ANSWERS = 'mq:answers';
  const SS_CURSOR = 'mq:cursor';
  const SS_FIRST_NAME = 'mq:first_name';
  const SS_SESSION_ID = 'mq:session_id';
  const SS_Q_ENTRY_TS = 'mq:q_entry_ts';
  const LS_COMPLETED = 'mq:completed:' + CFG.quizId;
  const LS_EMAIL_QUEUE = 'mq:email_queue';

  // ---------- PostHog wrapper ----------
  // PostHog loads from theme.liquid; this is a no-op until it's ready.
  function _quizSessionId() {
    try {
      let id = sessionStorage.getItem(SS_SESSION_ID);
      if (!id) {
        id = 'qs_' + Date.now().toString(36) + '_' + Math.random().toString(36).slice(2, 10);
        sessionStorage.setItem(SS_SESSION_ID, id);
      }
      return id;
    } catch (e) { return 'qs_anon'; }
  }
  function _capture(event, props) {
    try {
      if (window.posthog && typeof window.posthog.capture === 'function') {
        const merged = Object.assign({
          quiz_id: CFG.quizId,
          quiz_session_id: _quizSessionId(),
        }, CFG.offerVersion ? { offer_version: CFG.offerVersion } : null, props || {});
        // Everbright fires the same taxonomy as Mighty, but under an `eb_`
        // prefix (eb_started, eb_completed, eb_offer_viewed…) so the two
        // quizzes never collide in the PostHog event list. Mighty keeps the
        // bare `quiz_*` names. `quiz_id` is still on every event either way.
        const name = _isEverbrightQuiz()
          ? event.replace(/^quiz_/, 'eb_')
          : event;
        window.posthog.capture(name, merged);
      }
    } catch (e) { /* analytics never blocks UX */ }
  }
  function _markQuestionEntry() {
    try { sessionStorage.setItem(SS_Q_ENTRY_TS, String(Date.now())); } catch (e) {}
  }

  // ---------- Meta Pixel + GA4 — funnel attribution ----------
  // Mirrors the LP5a-v3 pattern (page.lp5a-v3.liquid):
  //   ViewContent fires once when the buy-box (#offer) crosses 50% of viewport.
  //   AddToCart fires when #cta-main is clicked.
  // Quiz buy-box uses /cart/clear?return_to=/cart/add permalinks — Shopify's
  // auto-AddToCart only fires on direct /cart/add.js POSTs (per
  // memory `joinmelina.com Meta pixel / CAPI stack`), so manually firing here
  // doesn't double-fire. content_ids use NUMERIC variant ids to match the
  // Shopify→Meta Sales Channel format on Purchase events (CAPI dedup).
  const _PIXEL_PLAN_OFFER = {
    '30':   { variant_id: '48982660284736', value: 39,  name: 'Mighty 30-Day Subscription' },
    'once': { variant_id: '48982660284736', value: 79,  name: 'Mighty 30-Day One-Time' },
  };
  // ViewContent surfaces the offer variant (30-day supply, sub + one-time share
  // it). Hero value = the recommended sub first-month total ($39) so Meta's
  // value-based optimization weights the right page.
  const _PIXEL_VC_VARIANT_IDS = ['48982660284736'];
  const _PIXEL_VC_VALUE = 39;

  const _PIXEL_UID_KEY = 'mq_uid';
  function _pixelExternalId() {
    try {
      let uid = localStorage.getItem(_PIXEL_UID_KEY);
      if (!uid) {
        uid = 'mqu-' + Date.now().toString(36) + '-' + Math.random().toString(36).slice(2, 10);
        localStorage.setItem(_PIXEL_UID_KEY, uid);
      }
      return uid;
    } catch (e) { return null; }
  }
  function _pixelGetCookie(name) {
    const m = document.cookie.match('(?:^|; )' + name + '=([^;]+)');
    return m ? decodeURIComponent(m[1]) : null;
  }
  function _pixelEnrichOpts(opts) {
    opts = opts || {};
    const eid = _pixelExternalId();
    if (eid) opts.external_id = eid;
    const fbc = _pixelGetCookie('_fbc'), fbp = _pixelGetCookie('_fbp');
    if (fbc && !opts.fbc) opts.fbc = fbc;
    if (fbp && !opts.fbp) opts.fbp = fbp;
    opts.client_user_agent = navigator.userAgent;
    return opts;
  }
  function _pixelMkEventId(label) {
    return 'mq-' + label + '-' + Date.now().toString(36) + '-' + Math.random().toString(36).slice(2, 8);
  }
  function _fb(track, event, params, opts) {
    if (!window.fbq) return;
    try { window.fbq(track, event, params || {}, _pixelEnrichOpts(opts)); } catch (e) {}
  }
  function _gtag() {
    if (!window.gtag) return;
    try { window.gtag.apply(null, arguments); } catch (e) {}
  }
  // Everbright behavior (eb_ event prefix, EB_* pixel events, the v3 result
  // render, EB routing) is a property of the BRAND, not of one quiz id — so
  // it keys off CFG.product. Every Everbright quiz gets it for free; before
  // 2026-07-26 this was ~11 hardcoded `quizId === 'everbright-quiz-v1'`
  // checks and a new EB quiz silently fell through to Mighty behavior.
  function _isEverbrightQuiz() {
    return CFG.product === 'everbright';
  }
  function _isDizzyQuiz() {
    return CFG.quizId === 'mighty-dizzy-v1';
  }
  function _ebAnalyticsPayload(routing) {
    routing = routing || {};
    const sigs = Array.isArray(routing.signatures) ? routing.signatures : [];
    const sigCode = sigs.join('_') || 'NONE';
    const phase = routing.phase || '';
    const dose = routing.dose || 'F';
    return {
      eb_phase: phase,
      eb_signatures: sigCode,
      eb_top_signature: sigs[0] || 'NONE',
      eb_dose: dose,
      eb_age_band: routing.age_band || '',
      eb_q_code: phase + '_' + sigCode + '_' + dose,
    };
  }

  let _vcFired = false;
  let _vcPixelFired = false;
  function _bindViewContent() {
    if (_vcPixelFired) return;
    if (!('IntersectionObserver' in window)) return;
    const target = ROOT.querySelector('#offer');
    if (!target) return;
    const obs = new IntersectionObserver((entries, io) => {
      entries.forEach((e) => {
        if (!e.isIntersecting) return;

        if (!_vcFired) {
          _vcFired = true;
          _capture('quiz_view_content', {
            event_id: _pixelMkEventId('vc'),
            value: _PIXEL_VC_VALUE,
            route_variant: state.variant || '',
            archetype: state.variant || '',
            modifiers: (state.modifiers || []).join(','),
            had_email: Boolean(state.email),
          });
        }

        if (_vcPixelFired) return;
        if (!window.fbq) {
          io.unobserve(target);
          setTimeout(() => { if (!_vcPixelFired) io.observe(target); }, 250);
          return;
        }
        _vcPixelFired = true;
        io.disconnect();
        const eid = _pixelMkEventId('vc');
        _fb('track', 'ViewContent', {
          content_ids: _PIXEL_VC_VARIANT_IDS.map(Number),
          content_type: 'product',
          content_name: 'Mighty Quiz Result',
          value: _PIXEL_VC_VALUE,
          currency: 'USD',
        }, { eventID: eid });
        _gtag('event', 'view_item', {
          event_id: eid,
          currency: 'USD',
          value: _PIXEL_VC_VALUE,
          items: _PIXEL_VC_VARIANT_IDS.map((id) => ({
            item_id: id,
            item_name: 'Mighty 30-Day',
            currency: 'USD',
          })),
        });
      });
    }, { threshold: 0 });
    obs.observe(target);
  }
  function _bindAddToCart() {
    const cta = ROOT.querySelector('#cta-main');
    if (!cta || cta.dataset.mqAtcBound === '1') return;
    cta.dataset.mqAtcBound = '1';
    cta.addEventListener('click', () => {
      const selected = ROOT.querySelector('.bb-plan.is-selected');
      const planId = (selected && selected.dataset.plan) || '30';
      const offer = _PIXEL_PLAN_OFFER[planId] || _PIXEL_PLAN_OFFER['30'];
      const eid = _pixelMkEventId('atc');
      _fb('track', 'AddToCart', {
        content_ids: [Number(offer.variant_id)],
        content_name: offer.name,
        content_type: 'product',
        value: offer.value,
        currency: 'USD',
      }, { eventID: eid });
      _gtag('event', 'add_to_cart', {
        event_id: eid,
        currency: 'USD',
        value: offer.value,
        items: [{ item_id: offer.variant_id, item_name: offer.name, price: offer.value, currency: 'USD' }],
      });
      _capture('quiz_add_to_cart', { event_id: eid, plan: planId, value: offer.value });
    });
  }
  function _msOnQuestion() {
    try {
      const ts = parseInt(sessionStorage.getItem(SS_Q_ENTRY_TS) || '0', 10);
      return ts ? (Date.now() - ts) : null;
    } catch (e) { return null; }
  }

  function saveSession() {
    try {
      sessionStorage.setItem(SS_ANSWERS, JSON.stringify(state.answers));
      sessionStorage.setItem(SS_CURSOR, String(state.cursor));
      if (state.firstName) sessionStorage.setItem(SS_FIRST_NAME, state.firstName);
    } catch (e) { /* private mode etc. — silently ignore */ }
  }
  function loadSession() {
    try {
      const a = sessionStorage.getItem(SS_ANSWERS);
      const c = sessionStorage.getItem(SS_CURSOR);
      const n = sessionStorage.getItem(SS_FIRST_NAME);
      if (a) state.answers = JSON.parse(a);
      if (c) state.cursor = parseInt(c, 10) || 0;
      if (n) state.firstName = n;
    } catch (e) { /* ignore */ }
  }

  // ---------- State ----------
  const state = {
    answers: {},        // { q1: 'female', q3: ['throbbing', 'light'], ... }
    cursor: 0,          // index into CFG.questionIds
    stage: 'quiz',      // 'quiz' | 'email' | 'loading' | 'result'
  };

  // ---------- Stage transitions ----------
  function setStage(name) {
    state.stage = name;
    ROOT.setAttribute('data-state', name);
    ROOT.querySelectorAll('.mq__stage').forEach((el) => {
      el.hidden = el.getAttribute('data-stage') !== name;
    });
  }

  function showQuestion(idx) {
    const ids = CFG.questionIds || [];
    if (idx < 0 || idx >= ids.length) return;
    state.cursor = idx;
    const qid = ids[idx];
    const qs = ROOT.querySelectorAll('.mq__question');
    qs.forEach((el) => {
      el.hidden = el.getAttribute('data-question-id') !== qid;
    });
    // progress — recompute against non-skipped ids so conditional questions
    // (e.g. q8_v1 when q1_v1='male') don't inflate the denominator.
    // Intro splash is a teaser, not a question — hide the stage header.
    const isIntro = qid === 'intro_splash';
    const stageHeader = ROOT.querySelector('.mq__stage[data-stage="quiz"] .mq__stage-header');
    if (stageHeader) stageHeader.hidden = isIntro;
    const visible = ids.filter((q) => !_shouldSkipQuestion(q, state.answers) && q !== 'intro_splash');
    const visibleIdx = visible.indexOf(qid);
    const fill = ROOT.querySelector('[data-mq-progress-fill]');
    const count = ROOT.querySelector('[data-mq-progress-count]');
    if (!isIntro) {
      if (fill) fill.style.width = (((visibleIdx + 1) / visible.length) * 100) + '%';
      if (count) count.textContent = (visibleIdx + 1) + ' / ' + visible.length;
    }
    const qEl = ROOT.querySelector('.mq__question[data-question-id="' + qid + '"]');
    if (!qEl) { saveSession(); return; }
    if (state.stage === 'quiz') {
      window.scrollTo({ top: 0, left: 0, behavior: 'auto' });
    }
    _markQuestionEntry();
    _capture('quiz_question_viewed', {
      qid: qid,
      step: visibleIdx + 1,
      total_steps: visible.length,
      question_type: qEl.getAttribute('data-question-type') || 'single_select',
    });
    // Interstitial: dynamic copy on entry, single Continue → advance, no answer required.
    if (qEl.getAttribute('data-question-type') === 'interstitial') {
      renderInterstitial(qEl, state.answers);
      const cont = qEl.querySelector('[data-mq-continue]');
      if (cont) cont.disabled = false;
      // Pulse interstitial only — show a brief "thinking" beat so the page
      // feels like it's actually considering the user's answers, not just
      // jump-cutting to the next screen.
      const thinking = qEl.querySelector('[data-mq-thinking]');
      if (qid === 'interstitial_pulse' && thinking) {
        qEl.classList.add('is-thinking');
        setTimeout(() => { qEl.classList.remove('is-thinking'); }, 1500);
      }
      saveSession();
      return;
    }
    // restore selected state from existing answers
    const ans = state.answers[qid];
    const opts = qEl.querySelectorAll('.mq__option');
    opts.forEach((o) => {
      const v = o.getAttribute('data-value');
      const selected = Array.isArray(ans) ? ans.includes(v) : ans === v;
      o.setAttribute('data-selected', selected ? 'true' : 'false');
    });
    // continue button enabled-state for multi-select
    const cont = qEl.querySelector('[data-mq-continue]');
    if (cont) cont.disabled = !ans || (Array.isArray(ans) && ans.length === 0);
    saveSession();
  }

  // ---------- Interstitial copy ----------
  // Mirrors the symptom×trigger pairing pattern so the user feels heard before
  // the harder questions (q6 "what have you tried", q8 pregnancy gate).
  const _INT_PAIRS = [
    { sym: 'throbbing',   trg: 'hormonal', txt: 'throbbing pain that tracks your hormonal shifts' },
    { sym: 'behind_eyes', trg: 'hormonal', txt: 'behind-the-eyes pressure that tracks your hormonal shifts' },
    { sym: 'light',       trg: 'stress',   txt: 'light sensitivity that spikes with stress' },
    { sym: 'sound',       trg: 'stress',   txt: 'sound sensitivity that spikes with stress' },
    { sym: 'nausea',      trg: 'foods',    txt: 'nausea that hits with specific foods' },
    { sym: 'nausea',      trg: 'skipped',  txt: 'nausea that hits when you skip meals' },
    { sym: 'aura',        trg: 'weather',  txt: 'visual aura before weather and pressure shifts' },
    { sym: 'brain_fog',   trg: 'sleep',    txt: 'the brain-fog hangover paired with poor sleep' },
    { sym: 'throbbing',   trg: 'screens',  txt: 'throbbing pain after long stretches on screens' },
  ];
  const _INT_DRIVERS = {
    stress:   'a single underlying driver: how your nervous system handles depletion',
    sleep:    'a single underlying driver: how your nervous system handles depletion',
    skipped:  'a single underlying driver: how your nervous system handles depletion',
    hormonal: 'a single underlying driver: how your brain responds to hormonal shifts',
    weather:  'a single underlying driver: how your brain regulates pressure changes',
    foods:    'a single underlying driver: how your gut and brain talk to each other',
    screens:  'a single underlying driver: how your visual system handles overload',
    unknown:  'a single underlying driver',
  };
  const _INT_SYM_FALLBACK = {
    throbbing: 'throbbing pain', behind_eyes: 'pressure behind the eyes',
    light: 'light sensitivity', sound: 'sound sensitivity', nausea: 'nausea',
    aura: 'visual aura', vestibular: 'dizziness and balance shifts',
    brain_fog: 'a post-attack brain-fog hangover',
  };
  const _INT_TRG_FALLBACK = {
    stress: 'stress', hormonal: 'hormonal shifts', sleep: 'poor sleep',
    weather: 'weather changes', screens: 'screens', foods: 'specific foods',
    skipped: 'skipped meals', unknown: "triggers you haven't pinned down",
  };

  function renderInterstitial(qEl, answers) {
    if (qEl.classList.contains('mq__interstitial--eb')) {
      renderEverbrightInterstitial(qEl, answers);
      return;
    }

    const symptoms = answers.q3_v1 || [];
    const triggers = answers.q4_v1 || [];
    let phrase = null;
    for (const p of _INT_PAIRS) {
      if (symptoms.includes(p.sym) && triggers.includes(p.trg)) { phrase = p.txt; break; }
    }
    if (!phrase) {
      const sym = symptoms.map((s) => _INT_SYM_FALLBACK[s]).filter(Boolean).slice(0, 2).join(' and ');
      const trg = (triggers.map((t) => _INT_TRG_FALLBACK[t]).filter(Boolean)[0]) || null;
      if (sym && trg) phrase = sym + ', set off by ' + trg;
      else if (sym) phrase = sym;
      else phrase = 'your symptoms alongside your triggers';
    }
    let driver = null;
    for (const t of triggers) { if (_INT_DRIVERS[t]) { driver = _INT_DRIVERS[t]; break; } }
    if (!driver) driver = _INT_DRIVERS.unknown;
    const symEl = qEl.querySelector('[data-mq-int-symptom-trigger]');
    if (symEl) symEl.textContent = phrase;
    const drvEl = qEl.querySelector('[data-mq-int-driver]');
    if (drvEl) drvEl.textContent = driver;
  }

  function renderEverbrightInterstitial(qEl, answers) {
    const a = answers || {};
    const ebRoot = qEl.matches('.mq__interstitial--eb')
      ? qEl
      : qEl.querySelector('.mq__interstitial--eb');
    if (!ebRoot) return;

    _ebIntRecap(ebRoot, a);
    _ebIntPlaceDot(ebRoot, String(a.age || ''));
  }

  // Personalized lede — weaves their symptoms and stage into the Mighty-style
  // "combination you're describing" sentence with highlight pills. Built from
  // answers, never from routing codes.
  const _EB_INT_SYMPTOM_WORDS = {
    fatigue: 'fatigue', fog: 'brain fog', concentrate: 'trouble focusing',
    motivation: 'low motivation', crash: 'afternoon crashes',
    sleep: 'restless sleep', skin: 'duller skin', mood: 'mood swings',
    recovery: 'slower recovery',
  };
  const _EB_INT_CYCLE_WORDS = {
    regular: 'still have a regular cycle', postpartum: "are postpartum",
    peri: 'are in perimenopause', meno: 'are in menopause',
    postmeno: 'are postmenopause',
  };

  function _ebIntRecap(ebRoot, a) {
    const host = ebRoot.querySelector('[data-eb-int-recap]');
    if (!host) return;
    const hl = function(s) { return '<span class="mq__int-hl">' + s + '</span>'; };
    const syms = _ebSymptoms(a).map(function(k) { return _EB_INT_SYMPTOM_WORDS[k]; }).filter(Boolean);
    const cyclePhrase = _EB_INT_CYCLE_WORDS[String(a.cycle || '')] || '';
    const driver = ebRoot.querySelector('[data-eb-int-driver]');
    let html;
    if (syms.length) {
      // Mighty-style: at most two symptoms, no "(+N more)" tail.
      const symHtml = syms.slice(0, 2).map(hl).join(' and ');
      html = "The combination you're describing — " + symHtml +
        (cyclePhrase ? ', while you ' + hl(cyclePhrase) : '') +
        ' — isn\'t random. And it\'s not <em>"just aging."</em>';
    } else {
      // No symptoms flagged (proactive path) — there's no "pattern" to
      // attribute, so the driver line is hidden and the chart carries the beat.
      html = "Nothing major yet — and that's the point. You want to " + hl('stay ahead') + '.';
      if (driver) driver.hidden = true;
    }
    host.innerHTML = html;
  }

  // "You are here" — place the marker on the NAD+ curve by age band.
  const _EB_INT_AGE_PCT = { u40: 0.3, '40_49': 0.5, '50_59': 0.7, '60p': 0.85 };
  function _ebIntPlaceDot(ebRoot, age) {
    const curve = ebRoot.querySelector('[data-eb-int-curve]');
    const dot = ebRoot.querySelector('[data-eb-int-dot]');
    if (!curve || !dot || !curve.getTotalLength) return;
    const pct = _EB_INT_AGE_PCT[age] || 0.5;
    let tries = 0;
    (function place() {
      const total = curve.getTotalLength();
      if (!total && tries++ < 20) { requestAnimationFrame(place); return; }
      if (!total) return;
      const pt = curve.getPointAtLength(total * pct);
      dot.setAttribute('transform', 'translate(' + pt.x + ',' + pt.y + ')');
      dot.setAttribute('visibility', 'visible');
    })();
  }

  // q8_v1 is conditional — male respondents skip it entirely. No need
  // to ask, no safety routing risk, and asking would feel tone-deaf.
  function _shouldSkipQuestion(qid, answers) {
    if (qid === 'q8_v1' && answers && answers.q1_v1 === 'male') return true;
    // Dizzy: the studies-breakdown interstitial only shows to people who
    // said the research matters ("very"); everyone else goes straight to
    // the timeline.
    if (qid === 'int_studies' && _isDizzyQuiz()) {
      return !answers || answers.q8_studies !== 'very';
    }
    return false;
  }
  function _nextCursor(from, dir) {
    const ids = CFG.questionIds || [];
    let i = from + dir;
    while (i >= 0 && i < ids.length && _shouldSkipQuestion(ids[i], state.answers)) i += dir;
    return i;
  }

  function advance() {
    const ids = CFG.questionIds || [];
    const curId = ids[state.cursor];
    if (curId && curId !== 'intro_splash') {
      const v = state.answers[curId];
      const valStr = Array.isArray(v) ? v.join(',') : (v == null ? '' : String(v));
      const answerProps = _isEverbrightQuiz()
        ? { q_value_code: curId + '_answered' }
        : { value: valStr };
      _capture('quiz_question_answered', Object.assign({
        qid: curId,
        step: state.cursor + 1,
        ms_on_question: _msOnQuestion(),
      }, answerProps));
      if (_isEverbrightQuiz()) {
        const _ebEid = _pixelMkEventId('eb-q-answered');
        _fb('trackCustom', 'EB_QuizQuestionAnswered', { quiz_id: MQ_CONFIG.quizId, q_id: curId, event_id: _ebEid }, { eventID: _ebEid });
      }
    }
    const next = _nextCursor(state.cursor, +1);
    if (next < ids.length) {
      showQuestion(next);
    } else if (computeRouting(state.answers).variant === 'not_recommended') {
      // Safety gate: q8_v1="yes" — skip the email gate entirely.
      // No email collection, no Klaviyo, no purchase nurture flow.
      // Show the not-recommended LP directly.
      state.variant = 'not_recommended';
      state.modifiers = [];
      setStage('loading');
      if (window.MQ.runLoadingThenReveal) window.MQ.runLoadingThenReveal();
    } else {
      setStage('email');
    }
  }
  // ---------- Quiz interactions ----------
  function bindQuizHandlers() {
    ROOT.querySelectorAll('.mq__question').forEach((qEl) => {
      const qid = qEl.getAttribute('data-question-id');
      const qtype = qEl.getAttribute('data-question-type');
      const oneTap = qEl.getAttribute('data-one-tap') === 'true';
      let oneTapTimer = null;  // re-tap within the 200ms flash must not queue a second advance

      if (qtype === 'interstitial') {
        const cont = qEl.querySelector('[data-mq-continue]');
        if (cont) cont.addEventListener('click', advance);
        return;
      }

      qEl.querySelectorAll('.mq__option').forEach((opt) => {
        opt.addEventListener('click', () => {
          const v = opt.getAttribute('data-value');
          if (qtype === 'single_select') {
            state.answers[qid] = v;
            qEl.querySelectorAll('.mq__option').forEach((o) => {
              o.setAttribute('data-selected', o === opt ? 'true' : 'false');
            });
            saveSession();
            if (oneTap) {
              clearTimeout(oneTapTimer);
              oneTapTimer = setTimeout(advance, 200);  // brief flash before advance
            }
          } else {
            // multi_select: toggle
            const cur = state.answers[qid] || [];
            const next = cur.includes(v) ? cur.filter((x) => x !== v) : cur.concat([v]);
            state.answers[qid] = next;
            opt.setAttribute('data-selected', next.includes(v) ? 'true' : 'false');
            const cont = qEl.querySelector('[data-mq-continue]');
            if (cont) cont.disabled = next.length === 0;
            saveSession();
          }
        });
      });

      const cont = qEl.querySelector('[data-mq-continue]');
      if (cont) cont.addEventListener('click', advance);
    });
  }

  // ---------- Email gate ----------
  function bindEmailHandlers() {
    const form = ROOT.querySelector('[data-mq-email-form]');
    if (!form) return;
    form.addEventListener('submit', (e) => {
      e.preventDefault();
      const fd = new FormData(form);
      const email = String(fd.get('email') || '').trim();
      const firstName = String(fd.get('first_name') || '').trim();
      const errEl = ROOT.querySelector('[data-mq-email-error]');
      if (!email || !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
        if (errEl) { errEl.textContent = 'That email looks off — try again?'; errEl.hidden = false; }
        return;
      }
      if (errEl) errEl.hidden = true;
      submitEmail(email, firstName).catch(() => { /* token/Klaviyo errors must not block UX */ });
    });
    const skip = ROOT.querySelector('[data-mq-email-skip]');
    if (skip) skip.addEventListener('click', () => {
      if (_isDizzyQuiz()) return; // no skip path on dizzy (markup absent; guard anyway)
      const routing = computeRouting(state.answers);
      state.variant = routing.variant;
      state.modifiers = routing.modifiers;
      _capture('quiz_skip_to_results', {
        route_variant: routing.variant,
        archetype: routing.variant,
      });
      setStage('loading');
      runLoadingThenReveal();
    });
    // Show the email gate as a tracked step.
    const emailStage = ROOT.querySelector('.mq__stage[data-stage="email"]');
    if (emailStage) {
      const obs = new MutationObserver(() => {
        if (state.stage === 'email') {
          const routing = computeRouting(state.answers);
          _capture('quiz_email_gate_viewed', { route_variant: routing.variant });
          if (_isEverbrightQuiz()) {
            const _ebEid = _pixelMkEventId('eb-gate');
            _fb('trackCustom', 'EB_QuizEmailGate', { quiz_id: MQ_CONFIG.quizId, event_id: _ebEid }, { eventID: _ebEid });
          }
          obs.disconnect();
        }
      });
      obs.observe(ROOT, { attributes: true, attributeFilter: ['data-state'] });
    }
  }

  async function submitEmail(email, firstName) {
    const routing = window.MQ.computeRouting ? window.MQ.computeRouting(state.answers) : { variant: 'otc_reliant', modifiers: [] };
    state.email = email;
    state.firstName = firstName;
    state.variant = routing.variant;
    state.modifiers = routing.modifiers;

    // PostHog: stitch anonymous → identified person, then record submission.
    try {
      if (window.posthog && typeof window.posthog.identify === 'function') {
        window.posthog.identify(email, {
          email: email,
          first_name: firstName || undefined,
          quiz_id: CFG.quizId,
          archetype: routing.variant,
        });
      }
    } catch (e) {}
    _capture('quiz_email_submitted', {
      route_variant: routing.variant,
      archetype: routing.variant,
    });
    if (_isEverbrightQuiz()) {
      const _ebEid = _pixelMkEventId('eb-submit');
      _fb('trackCustom', 'EB_QuizEmailSubmit', { quiz_id: MQ_CONFIG.quizId, event_id: _ebEid }, { eventID: _ebEid });
    }

    // Meta Pixel: fire `Lead` once per session on a valid email submit.
    // Klaviyo's API form (this page) does not auto-fire Meta events. Session
    // guard avoids double-fire from the duplicated inline + external script
    // execution in this section. Uses _fb (enriched with external_id, fbc,
    // fbp, client_user_agent) so this matches the LP5a-v3 surface.
    try {
      if (!sessionStorage.getItem('mq_lead_fired')) {
        const leadEid = _pixelMkEventId('lead');
        _fb('track', 'Lead', {
          content_name: _isEverbrightQuiz() ? 'Everbright Quiz' : (_isDizzyQuiz() ? 'Mighty Diz Quiz' : 'Mighty Quiz'),
          content_category: _isEverbrightQuiz() ? (routing.phase || '') : routing.variant,
        }, { eventID: leadEid });
        sessionStorage.setItem('mq_lead_fired', '1');
      }
    } catch (e) {}

    // Safety gate hard-stop: never submit pregnancy-routed users to the
    // standard purchase nurture list/flow. The email gate UI also bypasses
    // this branch (see advance()), so this guard is belt-and-suspenders.
    if (routing.variant === 'not_recommended') {
      setStage('loading');
      if (window.MQ.runLoadingThenReveal) window.MQ.runLoadingThenReveal();
      return;
    }
    // Build the AES-GCM token first so both the profile property bundle and
    // the result-page URL write reference the same opaque blob.
    try {
      state.resultToken = await buildResultToken(routing, state.answers);
    } catch (e) {
      state.resultToken = '';
    }
    // Two POSTs to Klaviyo:
    //  (a) subscribe profile to Master List with stable per-question + result
    //      properties (the email template's token surface).
    //  (b) fire a `Quiz Completed` custom event with full per-completion
    //      payload (incl. pattern_summary) — the Quiz Result Flow triggers
    //      on this event, NOT on list subscription. Decouples the quiz email
    //      from the existing Master-List welcome flow (operator-side
    //      conditional split: if quiz_id is set, 24h delay before continuing).
    queueKlaviyoPost(email, firstName, routing);
    queueKlaviyoEvent(email, firstName, routing);
    // Dizzy has no result page: fire completion events, show the short
    // loading beat (gives the queued Klaviyo fetches time to land before
    // navigation aborts them), then redirect straight to the exit LP.
    if (_isDizzyQuiz()) {
      _capture('quiz_completed', { quiz_id: CFG.quizId, terminal: 'redirect' });
      _capture('quiz_exit_redirect', { destination: CFG.exitUrl || '' });
      setStage('loading');
      setTimeout(function () {
        if (CFG.exitUrl) window.location.assign(CFG.exitUrl);
      }, 1600);
      return;
    }
    setStage('loading');
    if (window.MQ.runLoadingThenReveal) window.MQ.runLoadingThenReveal();
  }

  function queueKlaviyoPost(email, firstName, routing) {
    // Two POSTs to two different endpoints:
    //  (a) /client/profiles/      — writes the profile properties (the
    //      durable per-quiz schema). This is the load-bearing call.
    //  (b) /client/subscriptions/ — grants email-marketing consent + adds
    //      to the list. Without explicit `subscriptions.email.marketing
    //      .consent = SUBSCRIBED` somewhere in the payload, Klaviyo leaves
    //      the profile at "Never Subscribed" and excludes it from sends.
    //
    // Why split: /client/subscriptions/ currently rejects `subscriptions`
    // nested inside profile.data.attributes ("'subscriptions' is not a
    // valid field for the resource 'profile'"), and that 400 used to drop
    // the WHOLE payload — meaning properties never wrote. Splitting means
    // even if the consent endpoint's schema drifts again, profile data
    // still lands.
    const cid = encodeURIComponent(CFG.klaviyoPublicKey);
    const profilePayload = {
      data: {
        type: 'profile',
        attributes: {
          email: email,
          first_name: firstName || undefined,
          properties: buildProfileProperties(routing),
        },
      },
    };
    // Klaviyo's /client/subscriptions/ rejected the explicit `subscriptions`
    // field at every location we tried — inside profile.data.attributes:
    // "'subscriptions' is not a valid field for the resource 'profile'", and
    // at data.attributes: "'subscriptions' is not a valid field for the
    // resource 'subscription'". Per Klaviyo's own docs (revision 2025-04-15):
    // "If a subscriptions object is not provided, subscriptions are defaulted
    // to MARKETING." Omit the field entirely — POSTing to this endpoint with
    // a list relationship IS the marketing-consent action.
    const subPayload = {
      data: {
        type: 'subscription',
        attributes: {
          custom_source: 'Quiz — ' + CFG.quizId,
          profile: {
            data: {
              type: 'profile',
              attributes: {
                email: email,
              },
            },
          },
        },
        relationships: {
          list: { data: { type: 'list', id: CFG.klaviyoListId } },
        },
      },
    };
    const queue = readEmailQueue();
    queue.push({
      url: 'https://a.klaviyo.com/client/profiles/?company_id=' + cid,
      payload: profilePayload, attempts: 0, ts: Date.now(),
    });
    queue.push({
      url: 'https://a.klaviyo.com/client/subscriptions/?company_id=' + cid,
      payload: subPayload, attempts: 0, ts: Date.now(),
    });
    writeEmailQueue(queue);
    flushEmailQueue();
  }
  function readEmailQueue() {
    try { return JSON.parse(localStorage.getItem(LS_EMAIL_QUEUE) || '[]'); }
    catch (e) { return []; }
  }
  function writeEmailQueue(q) {
    try { localStorage.setItem(LS_EMAIL_QUEUE, JSON.stringify(q)); } catch (e) {}
  }
  function flushEmailQueue() {
    const queue = readEmailQueue();
    if (queue.length === 0) return;
    const item = queue[0];
    // 4xx is a permanent payload-shape problem — retrying won't help, but
    // we still want the item out of the queue. The 5-attempt cap keeps a
    // bad item from looping forever even if the server keeps 5xx-ing.
    if (item.attempts >= 5) { queue.shift(); writeEmailQueue(queue); flushEmailQueue(); return; }
    item.attempts += 1;
    writeEmailQueue(queue);
    // Backwards compat: pre-split queue items have no `url` field — they
    // targeted /client/subscriptions/. Default to that so legacy items
    // drain rather than getting stuck.
    const url = item.url || ('https://a.klaviyo.com/client/subscriptions/?company_id=' + encodeURIComponent(CFG.klaviyoPublicKey));
    fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'revision': '2025-04-15' },
      body: JSON.stringify(item.payload),
    }).then((r) => {
      // 2xx (incl. 202) → drained successfully.
      // 4xx → payload is malformed; drop it so a stuck bad payload doesn't
      // wedge the queue forever blocking later items behind it.
      if (r.ok || r.status === 202 || (r.status >= 400 && r.status < 500)) {
        const q2 = readEmailQueue(); q2.shift(); writeEmailQueue(q2);
        flushEmailQueue();  // chain to next item
      }
      // 5xx → leave in queue, retry next page load (counts toward the 5-cap).
    }).catch(() => { /* network blip — leave in queue, retry next page load */ });
  }

  function queueKlaviyoEvent(email, firstName, routing) {
    // Klaviyo `client/events` public endpoint — fires a custom metric/event
    // on the same profile. The Quiz Result Flow triggers on this event;
    // event properties carry the full per-completion payload (incl.
    // pattern_summary) used by the email template.
    const payload = {
      data: {
        type: 'event',
        attributes: {
          properties: buildEventProperties(routing),
          metric: { data: { type: 'metric', attributes: { name: 'Quiz Completed' } } },
          profile: {
            data: {
              type: 'profile',
              attributes: {
                email: email,
                first_name: firstName || undefined,
              },
            },
          },
        },
      },
    };
    fetch('https://a.klaviyo.com/client/events/?company_id=' + encodeURIComponent(CFG.klaviyoPublicKey), {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'revision': '2025-04-15' },
      body: JSON.stringify(payload),
    }).catch(() => { /* event is fire-and-forget; the subscription POST is the durable one */ });
  }

  // Profile property schema. Stable per-profile traits: per-question answers,
  // routing decision, identity, result-link. Email-rendering tokens
  // (archetype_name / explainer / pattern_stat / variant_pitch / cart link)
  // are also written so the Klaviyo template's `{{ archetype_name }}` etc.
  // tokens resolve. Excluded by spec: q8_v1 (safety-gate users never reach
  // this code path anyway), pattern_summary (per-completion text — lives on
  // the event), and `email` (Klaviyo derives it from profile identity).
  function _dzAnswerProps() {
    const a = state.answers || {};
    const j = (v) => (Array.isArray(v) ? v : (v == null ? '' : v));
    return {
      dz_freq: j(a.q1_freq),
      dz_duration: j(a.q2_duration),
      dz_symptoms: j(a.q3_symptoms) || [],
      dz_triggers: j(a.q4_triggers) || [],
      dz_cutback: j(a.q4_cutback) || [],
      dz_support: j(a.q6_support) || [],
      dz_tried: j(a.q7_tried) || [],
      dz_studies: j(a.q8_studies),
    };
  }

  function buildProfileProperties(routing) {
    const token = state.resultToken || '';
    // mighty-dizzy-v1: dz_* schema. No archetype/result tokens (no result
    // page, no result email personalization) and no pattern_summary — the
    // Mighty fallback below reads q1_v1..q7_v1, which don't exist here.
    if (_isDizzyQuiz()) {
      return Object.assign({
        dz_quiz_completed: true,
        quiz_id: CFG.quizId,
        offer_version: CFG.offerVersion || '',
        dz_quiz_at: new Date().toISOString(),
        utm_source: new URLSearchParams(location.search).get('utm_source') || '',
        utm_campaign: new URLSearchParams(location.search).get('utm_campaign') || '',
      }, _dzAnswerProps());
    }
    // Everbright V2 hormone-quiz: phase + signature + dose schema.
    // Klaviyo properties are scoped with eb_quiz_* prefix; the eb_quiz_v key
    // pins the schema version so Klaviyo segments / flows can branch on it.
    if (_isEverbrightQuiz()) {
      var sigs = (routing.signatures || []).join('_');
      var topSig = (routing.signatures || [])[0] || '';
      return {
        eb_quiz_completed: true,
        eb_quiz_v: 'v3',
        quiz_id: CFG.quizId,
        // Raw per-question answers — the segmentation surface (parity with
        // Mighty's q1_v1..q7_v1).
        eb_quiz_age: state.answers.age,
        eb_quiz_symptoms: state.answers.symptoms || [],
        eb_quiz_goal: state.answers.goal,
        eb_quiz_cycle: state.answers.cycle,
        eb_quiz_energy: state.answers.energy,
        eb_quiz_tried: state.answers.tried || [],
        eb_quiz_duration: state.answers.duration,
        // Routing decision.
        eb_quiz_phase: routing.phase || '',
        eb_quiz_signatures: sigs,
        eb_quiz_top_signature: topSig,
        eb_quiz_dose: routing.dose || 'F',
        eb_quiz_age_band: routing.age_band || state.answers.age || '',
        // Acquisition attribution (parity with Mighty).
        utm_source: new URLSearchParams(location.search).get('utm_source') || '',
        utm_campaign: new URLSearchParams(location.search).get('utm_campaign') || '',
        // Email-template personalization tokens — human-readable, so a
        // Klaviyo template never has to map raw codes (parity with Mighty's
        // archetype_name / explainer / pattern_stat / variant_pitch).
        eb_quiz_phase_name: (CFG.phaseDisplayName || {})[routing.phase] || '',
        eb_quiz_phase_explainer: (CFG.phaseExplainer || {})[routing.phase] || '',
        eb_quiz_pitch: (CFG.variantPitch || {})[routing.phase] || '',
        eb_quiz_signature_name: (CFG.signatureDisplayName || {})[topSig] || '',
        eb_quiz_signature_receipt: (CFG.signatureReceiptLine || {})[topSig] || '',
        eb_quiz_state_token: token,
        eb_quiz_result_permalink: token ? buildResultPermalinkFromToken(token) : '',
        eb_quiz_at: new Date().toISOString(),
      };
    }
    return {
      q1_v1: state.answers.q1_v1,
      q2_v1: state.answers.q2_v1,
      q3_v1: state.answers.q3_v1,
      q4_v1: state.answers.q4_v1,
      q5_v1: state.answers.q5_v1,
      q6_v1: state.answers.q6_v1,
      q7_v1: state.answers.q7_v1,
      route_v1: routing.variant,
      mods_v1: routing.modifiers || [],
      quiz_id: CFG.quizId,
      offer_version: CFG.offerVersion || '',
      quiz_completed_at: new Date().toISOString(),
      quiz_state_token: token,
      quiz_result_permalink: token ? buildResultPermalinkFromToken(token) : '',
      utm_source: new URLSearchParams(location.search).get('utm_source') || '',
      utm_campaign: new URLSearchParams(location.search).get('utm_campaign') || '',
      // Personalization tokens for the post-capture email template
      archetype_name: (CFG.archetypeNames || {})[routing.variant] || '',
      archetype_explainer: (CFG.archetypeExplainer || {})[routing.variant] || '',
      pattern_stat: (CFG.patternStat || {})[routing.variant] || '',
      variant_specific_one_paragraph_pitch: (CFG.variantPitch || {})[routing.variant] || '',
    };
  }

  // Event properties = full per-completion payload. `pattern_summary` is
  // computed text that varies per completion (different answer sets produce
  // different summaries), so it doesn't belong on the stable profile.
  function buildEventProperties(routing) {
    // mighty-dizzy-v1: dz_* answer keys, NO pattern_summary (the Mighty
    // fallback would build one from migraine phrase tables over answer ids
    // that don't exist here — the exact EB bug from the 2026-07-03 audit).
    if (_isDizzyQuiz()) {
      return Object.assign({
        quiz_id: CFG.quizId,
        quiz_session_id: _quizSessionId(),
        offer_version: CFG.offerVersion || '',
      }, _dzAnswerProps());
    }
    // EB carries its own answer keys and an EB-native pattern_summary —
    // without this branch the event ships Mighty's q1_v1..q7_v1 (all
    // undefined for EB) and a summary built from migraine phrase tables.
    if (_isEverbrightQuiz()) {
      return {
        quiz_id: CFG.quizId,
        quiz_session_id: _quizSessionId(),
        eb_quiz_age: state.answers.age,
        eb_quiz_symptoms: state.answers.symptoms || [],
        eb_quiz_goal: state.answers.goal,
        eb_quiz_cycle: state.answers.cycle,
        eb_quiz_energy: state.answers.energy,
        eb_quiz_tried: state.answers.tried || [],
        eb_quiz_duration: state.answers.duration,
        eb_quiz_phase: routing.phase || '',
        eb_quiz_signatures: (routing.signatures || []).join('_'),
        eb_quiz_top_signature: (routing.signatures || [])[0] || '',
        eb_quiz_dose: routing.dose || 'F',
        pattern_summary: buildEbPatternSummary(state.answers),
      };
    }
    return {
      quiz_id: CFG.quizId,
      quiz_session_id: _quizSessionId(),
      offer_version: CFG.offerVersion || '',
      q1_v1: state.answers.q1_v1,
      q2_v1: state.answers.q2_v1,
      q3_v1: state.answers.q3_v1,
      q4_v1: state.answers.q4_v1,
      q5_v1: state.answers.q5_v1,
      q6_v1: state.answers.q6_v1,
      q7_v1: state.answers.q7_v1,
      route_v1: routing.variant,
      mods_v1: routing.modifiers || [],
      pattern_summary: buildPatternSummary(state.answers),
    };
  }

  // EB pattern summary — human-readable prose from EB answer keys, parallel
  // to Mighty's buildPatternSummary. Ships as the `pattern_summary` event
  // property for the EB result-email template.
  const _EB_ENERGY_PHRASE = {
    pm: 'crashing hard in the afternoon', am: 'low from the morning on',
    swing: 'up and down through the day', steady: 'still steady — protecting it',
  };
  const _EB_DURATION_PHRASE = {
    recent: 'started recently', '6_12': 'going on 6–12 months',
    year: 'going on a year or more', always: 'going on as long as you can remember',
    proactive: '',
  };
  const _EB_TRIED_PHRASE = {
    hrt: 'HRT', nad: 'NAD+ supplements', adaptogens: 'adaptogens',
    collagen: 'collagen', greens: 'greens or multivitamins',
    diet: 'diet & exercise', caffeine: 'caffeine to push through',
  };
  const _EB_GOAL_PHRASE = {
    energy: 'steady energy', focus: 'sharp focus', glow: 'glowing skin',
    recovery: 'faster recovery', all: 'longevity',
  };

  function buildEbPatternSummary(a) {
    const parts = [];
    const syms = _ebSymptoms(a).map(function(k) { return _EB_INT_SYMPTOM_WORDS[k]; }).filter(Boolean);
    if (syms.length) {
      let s = syms.slice(0, 2).join(' and ');
      const en = _EB_ENERGY_PHRASE[String(a.energy || '')];
      if (en) s += ', energy ' + en;
      const dur = _EB_DURATION_PHRASE[String(a.duration || '')];
      if (dur) s += ', ' + dur;
      parts.push(s);
    } else {
      parts.push('no major symptoms yet — staying ahead of the shift');
    }
    const cyc = _EB_INT_CYCLE_WORDS[String(a.cycle || '')];
    if (cyc) parts.push('you ' + cyc);
    const triedArr = (Array.isArray(a.tried) ? a.tried : (a.tried ? [a.tried] : []))
      .filter(function(v) { return v !== 'nothing'; });
    if (triedArr.length) {
      parts.push("you've tried " + triedArr.slice(0, 2)
        .map(function(t) { return _EB_TRIED_PHRASE[t] || t; }).join(' and '));
    }
    const g = _EB_GOAL_PHRASE[String(a.goal || '')];
    if (g) parts.push('priority: ' + g);
    return parts.join('; ') + '.';
  }

  // ---------- Email-token helpers ----------
  // These produce human-readable summaries from raw enum answers. The output
  // ships to Klaviyo as the `pattern_summary` event property, then renders
  // in the email via the event.pattern_summary token.
  const _PATTERN_PHRASE = {
    new: 'new and still figuring out',
    few_per_year: 'occasional',
    few_per_month: 'a-few-a-month',
    frequent: 'frequent (8+ days a month)',
    constant: 'near-constant (15+ days a month)',
  };
  const _TRIGGER_PHRASE = {
    stress: 'stress', hormonal: 'hormonal shifts', sleep: 'poor sleep',
    weather: 'weather changes', screens: 'screen time', foods: 'specific foods',
    skipped: 'skipped meals', unknown: "triggers you haven't pinned down yet",
  };
  const _SYMPTOM_PHRASE = {
    throbbing: 'throbbing pain', behind_eyes: 'pressure behind the eyes',
    light: 'light sensitivity', sound: 'sound sensitivity', nausea: 'nausea',
    aura: 'visual aura', vestibular: 'dizziness and balance issues',
    brain_fog: 'a post-migraine brain-fog hangover',
  };
  const _TRIED_PHRASE = {
    otc: 'OTC pain relievers',
    rx_preventive: 'prescription preventives',
    botox: 'Botox or nerve blocks',
    triptan: 'triptans',
    supplement_formula: 'a migraine supplement formula',
    single_ingredients: 'single supplements like magnesium and B2',
    stacking_5_plus: 'stacking 5+ pills daily',
    lifestyle: 'lifestyle changes',
    nothing: 'nothing yet',
  };
  const _Q7_PHRASE = {
    no_diff: 'nothing made a real difference',
    worked_stopped: 'things that worked at first stopped working',
    helped_little: 'results were always partial',
    side_effects: 'side effects forced you to stop',
    havent_tried_much: "you haven't tried much yet",
  };

  function _list(arr, mapping, max) {
    // Defensive: if a non-array value sneaks in (e.g. legacy URL state),
    // coerce to array so .slice().map() doesn't blow up the whole render.
    if (!Array.isArray(arr)) arr = arr ? [arr] : [];
    return arr.slice(0, max || 2).map((v) => mapping[v] || v).join(' and ');
  }

  // Result-page-friendly humanizers — comma-joined (use _list with " and " for prose).
  const _AGE_PHRASE = {
    '18_29': '18–29', '30_39': '30s', '40_49': '40s', '50_59': '50s', '60_plus': '60+',
  };
  const _PATTERN_RESULT_PHRASE = {
    new: 'new pattern',
    few_per_year: 'a few times a year',
    few_per_month: 'a few times a month',
    frequent: 'frequent (8+/month)',
    constant: 'near-constant (15+/month)',
  };
  // .proj-readout-val needs the leading letter capped.
  function _cap(s) { return s ? s.charAt(0).toUpperCase() + s.slice(1) : s; }

  function _humanList(arr, mapping, max) {
    if (!Array.isArray(arr) || !arr.length) return '';
    const out = arr.slice(0, max || 3).map((v) => mapping[v] || v);
    if (out.length <= 1) return out.join('');
    if (out.length === 2) return out.join(' and ');
    return out.slice(0, -1).join(', ') + ', and ' + out[out.length - 1];
  }
  function _humanPattern(p) { return _PATTERN_RESULT_PHRASE[p] || p || ''; }
  function _humanAge(a) { return _AGE_PHRASE[a] || a || ''; }

  // ---------- Ingredient tags ----------
  // Each ingredient maps to ranked answer keys: the first matching answer
  // wins. Falls back to the foundational tag if no rule fires. The tags are
  // human-readable and tied directly to the user's answers, so they read as
  // "we read your quiz" rather than generic.
  const _ING_TAG_RULES = {
    mag: [
      { key: 'q3_v1', val: 'vestibular', txt: 'For your dizziness & balance attacks' },
      { key: 'q4_v1', val: 'sleep',    txt: 'For your sleep-related attacks' },
      { key: 'q4_v1', val: 'stress',   txt: 'For your stress trigger' },
      { key: 'q4_v1', val: 'hormonal', txt: 'For your hormonal-pattern attacks' },
      { key: 'q5_v1',  val: ['frequent', 'constant'], txt: 'For your frequent pattern' },
      { key: 'q3_v1', val: 'throbbing', txt: 'Steadies an over-firing brain' },
    ],
    b2: [
      { key: 'q3_v1', val: 'vestibular', txt: 'Studied for vestibular migraine' },
      { key: 'q5_v1',  val: ['frequent', 'constant'], txt: 'For your frequent pattern' },
      { key: 'q3_v1', val: 'brain_fog', txt: 'For your brain-fog hangover' },
      { key: 'q4_v1', val: 'stress',    txt: 'Recharges depleted brain energy' },
    ],
    coq: [
      { key: 'q3_v1', val: 'vestibular', txt: 'Mitochondrial support for vestibular type' },
      { key: 'q5_v1',  val: ['frequent', 'constant'], txt: 'For your frequent pattern' },
      { key: 'q3_v1', val: 'brain_fog', txt: 'For your brain-fog hangover' },
      { key: 'q4_v1', val: 'stress',    txt: 'For your stress trigger' },
      { key: 'q4_v1', val: 'screens',   txt: 'For your screens trigger' },
    ],
    feverfew: [
      { key: 'q3_v1', val: 'throbbing', txt: 'For your throbbing pain' },
      { key: 'q3_v1', val: 'light',     txt: 'For your light-sensitive attacks' },
      { key: 'q3_v1', val: 'sound',     txt: 'For your sound-sensitive attacks' },
      { key: 'q4_v1', val: 'weather',   txt: 'For your weather-pressure pattern' },
    ],
    methyl: [
      { key: 'q3_v1', val: 'aura',      txt: 'For your visual aura' },
      { key: 'q4_v1', val: 'hormonal',  txt: 'For your hormonal-shift pattern' },
      { key: 'q4_v1', val: 'foods',     txt: 'For your food-trigger sensitivity' },
    ],
    d3: [
      { key: 'q4_v1', val: 'weather',   txt: 'For your weather-pressure pattern' },
      { key: 'q5_v1',  val: ['frequent', 'constant'], txt: 'For your chronic pattern' },
    ],
  };

  function _matchesRule(rule, answers) {
    const ans = answers[rule.key];
    if (Array.isArray(rule.val)) {
      if (Array.isArray(ans)) return ans.some((a) => rule.val.includes(a));
      return rule.val.includes(ans);
    }
    if (Array.isArray(ans)) return ans.includes(rule.val);
    return ans === rule.val;
  }

  function personalizeIngredientTags(answers) {
    ROOT.querySelectorAll('[data-mq-ing-tag]').forEach((el) => {
      const slot = el.getAttribute('data-mq-ing-tag');
      const rules = _ING_TAG_RULES[slot] || [];
      for (const rule of rules) {
        if (_matchesRule(rule, answers)) {
          el.textContent = rule.txt;
          return;  // first match wins; preserves declared priority
        }
      }
      // No match → leave the static fallback in place.
    });
  }

  // ---------- Buy-box recap opener ----------
  // A single short line above the variant body that mirrors their answers
  // back. Reads "Built for a {pattern} pattern, set off by {top trigger}."
  function personalizeBuyBoxRecap(answers) {
    const el = ROOT.querySelector('[data-mq-bb-recap-opener]');
    if (!el) return;
    const pat = _humanPattern(answers.q5_v1);
    const triggers = Array.isArray(answers.q4_v1) ? answers.q4_v1 : [];
    const trg = triggers.map((t) => _TRIGGER_PHRASE[t]).filter(Boolean)[0];
    // Phrases like "a few times a month" already start with an article —
    // don't prepend another "a". Phrases like "new pattern" already end
    // with "pattern" — don't append a duplicate ("new pattern pattern").
    const startsWithArticle = /^(a |an |the )/i.test(pat);
    const endsWithPattern = / pattern$/i.test(pat);
    const article = startsWithArticle ? '' : 'a ';
    const tail = endsWithPattern ? '' : ' pattern';
    const parts = [];
    if (pat) parts.push('Built for ' + article + pat + tail);
    if (trg) parts.push('set off by ' + trg);
    el.textContent = parts.length ? parts.join(', ') + '.' : 'Built for someone with your pattern.';
  }

  // ---------- Match % ----------
  // A simple heuristic: signal density (more answers Mighty addresses → higher
  // match) capped between 86 and 96 to feel earned, not gimmicky.
  function _matchPct(answers, routing) {
    let s = 86;
    if ((answers.q3_v1 || []).length >= 2) s += 2;
    if ((answers.q3_v1 || []).length >= 4) s += 1;
    if ((answers.q4_v1 || []).length >= 2) s += 2;
    if (['frequent', 'constant', 'few_per_month'].indexOf(answers.q5_v1) !== -1) s += 2;
    if (routing.variant === 'rx_aware' || routing.variant === 'stacker') s += 2;
    if (routing.modifiers && routing.modifiers.length) s += 1;
    return Math.min(96, Math.max(86, s));
  }

  function buildPatternSummary(a) {
    const patKey = a.q5_v1;
    const patPhrase = _PATTERN_PHRASE[patKey] || patKey || '';
    const symptoms = _list(a.q3_v1, _SYMPTOM_PHRASE, 2);
    const triggers = _list(a.q4_v1, _TRIGGER_PHRASE, 2);
    // 'nothing' is the "haven't tried anything" placeholder, not a real
    // tried entry. Filter it so we don't generate "You've already tried
    // nothing yet, and nothing made a real difference" — both contradictory
    // and weird.
    const triedArr = Array.isArray(a.q6_v1) ? a.q6_v1.filter((v) => v !== 'nothing') : [];
    const tried = _list(triedArr, _TRIED_PHRASE, 2);
    // Only surface a q7 outcome if there was actually something tried —
    // otherwise "no real difference" is meaningless.
    const outcome = triedArr.length ? (_Q7_PHRASE[a.q7_v1] || '') : '';
    const parts = [];
    // 'new' doesn't slot into "{phrase} attacks" cleanly — the pattern
    // phrase is "new and still figuring out", which reads broken before
    // "attacks". Special-case to "early in your migraine journey".
    let s1 = '';
    if (patKey === 'new') {
      s1 = "You're early in your migraine journey";
    } else if (patPhrase) {
      s1 = "You're dealing with " + patPhrase + ' attacks';
    } else if (symptoms || triggers) {
      s1 = "You're dealing with attacks";
    }
    if (s1) {
      if (symptoms) s1 += ' — ' + symptoms;
      if (triggers) s1 += ' — set off most by ' + triggers;
      parts.push(s1 + '.');
    }
    if (tried) {
      let s2 = "You've already tried " + tried;
      if (outcome) s2 += ', and ' + outcome;
      parts.push(s2 + '.');
    }
    return parts.join(' ');
  }
  // Hardcoded canonical result-page URL. Do NOT derive from `location` — if
  // the page is served at a stale/redirect slug, that slug would get baked
  // into the Klaviyo `quiz_result_permalink` profile property and every
  // email CTA would 404 once the redirect lapses.
  const RESULT_PAGE_URL = 'https://joinmelina.com/pages/mighty-quiz';
  const V2_RESULT_PAGE_URL = 'https://joinmelina.com/pages/mighty-quiz-2';
  // Everbright now runs on two storefronts (clubeverbright.com and
  // joinmelina.com), so its result page can't be one constant — each EB quiz
  // YAML carries its own `result_page_url`. This fallback is the original
  // clubeverbright page, kept so an EB quiz that omits the field still builds
  // a working permalink instead of a Mighty one.
  const EB_RESULT_PAGE_URL = 'https://clubeverbright.com/pages/quiz';

  function buildResultPermalinkFromToken(token) {
    var baseUrl;
    if (CFG.resultPageUrl) baseUrl = CFG.resultPageUrl;
    else if (_isEverbrightQuiz()) baseUrl = EB_RESULT_PAGE_URL;
    else if (CFG.quizId === 'mighty-quiz-v2') baseUrl = V2_RESULT_PAGE_URL;
    else baseUrl = RESULT_PAGE_URL;
    return baseUrl + '?r=' + encodeURIComponent(token);
  }

  // ---------- Loading state ----------
  const LOADING_MIN_MS = 2500;
  const LOADING_MAX_MS = 3200;
  const LOADING_STEP_MS = 600;

  function runLoadingThenReveal() {
    const items = ROOT.querySelectorAll('.mq__loading-steps li');
    items.forEach((li) => li.removeAttribute('data-shown'));
    items.forEach((li, i) => {
      setTimeout(() => li.setAttribute('data-shown', 'true'), i * LOADING_STEP_MS);
    });
    const start = Date.now();
    function tryReveal() {
      const elapsed = Date.now() - start;
      if (elapsed >= LOADING_MIN_MS) {
        revealResult();
      } else {
        setTimeout(tryReveal, LOADING_MIN_MS - elapsed);
      }
    }
    setTimeout(tryReveal, LOADING_MIN_MS);
    setTimeout(() => { if (state.stage === 'loading') revealResult(); }, LOADING_MAX_MS);
  }

  function revealResult() {
    if (state.stage === 'result') return;     // idempotent
    setStage('result');
    if (window.MQ.renderResult) window.MQ.renderResult();
    const routing = computeRouting(state.answers);
    const ebProps = _isEverbrightQuiz() ? _ebAnalyticsPayload(routing) : {};

    // EB V2 dispatch — phase × signature × dose
    if (_isEverbrightQuiz()) {
      revealResultEverbright(routing, state.answers);
    }

    _capture('quiz_completed', Object.assign({
      route_variant: routing.variant,
      archetype: routing.variant,
      modifiers: (routing.modifiers || []).join(','),
      had_email: Boolean(state.email),
    }, ebProps));
    if (_isEverbrightQuiz()) {
      const _ebEid = _pixelMkEventId('eb-complete');
      _fb('trackCustom', 'EB_QuizComplete',
        Object.assign({ quiz_id: CFG.quizId, event_id: _ebEid }, ebProps),
        { eventID: _ebEid });
    }
  }

  function _bindEbResultCtas(root, routing, cartUrl) {
    const ebProps = _ebAnalyticsPayload(routing);
    const atcVariantId = (window.MQ_CONFIG && window.MQ_CONFIG.shopifyVariantId) || '';
    function atcValue() { return EB_PLAN_PRICE[state.ebPlan || 'sub'] || EB_PLAN_PRICE.sub; }
    function trackResultCta(cta, ctaLocation, target) {
      const eid = _pixelMkEventId('eb-result-cta');
      const props = Object.assign({
        cta_location: ctaLocation,
        target: target,
        event_id: eid,
      }, ebProps);
      _capture('quiz_cta_clicked', props);
      _fb('trackCustom', 'EB_ResultCtaClick', Object.assign({ quiz_id: CFG.quizId }, props), { eventID: eid });
    }
    // Meta AddToCart parity with Mighty's _bindAddToCart. EB buy CTAs are cart
    // permalinks (/cart/{variant}), so Shopify CAPI does NOT auto-fire AddToCart
    // on the permalink GET — we fire it client-side on the buy-CTA click. Bound
    // only to purchase-intent CTAs ([data-eb-cta]), never in-page scroll anchors.
    function trackAddToCart(ctaLocation) {
      const eid = _pixelMkEventId('eb-atc');
      _fb('track', 'AddToCart', {
        content_ids: atcVariantId ? [Number(atcVariantId)] : [],
        content_name: 'Everbright — 5-in-1 Revival Stack',
        content_type: 'product',
        value: atcValue(),
        currency: 'USD',
      }, { eventID: eid });
      _gtag('event', 'add_to_cart', {
        event_id: eid,
        currency: 'USD',
        value: atcValue(),
        items: atcVariantId ? [{
          item_id: Number(atcVariantId),
          item_name: 'Everbright — 5-in-1 Revival Stack',
          price: atcValue(),
          currency: 'USD',
        }] : [],
      });
      _capture('quiz_add_to_cart', Object.assign({
        event_id: eid,
        cta_location: ctaLocation,
        value: atcValue(),
      }, ebProps));
    }
    root.querySelectorAll('[data-eb-cta]').forEach(function(cta) {
      if (cta.dataset.ebAnalyticsBound === '1') return;
      cta.dataset.ebAnalyticsBound = '1';
      cta.addEventListener('click', function() {
        const target = cta.getAttribute('href') || cartUrl || '';
        const ctaLocation = cta.getAttribute('data-eb-cta') || '';
        trackResultCta(cta, ctaLocation, target);
        trackAddToCart(ctaLocation);
      });
    });
    root.querySelectorAll('[data-eb-scroll-cta]').forEach(function(cta) {
      if (cta.dataset.ebAnalyticsBound === '1') return;
      cta.dataset.ebAnalyticsBound = '1';
      cta.addEventListener('click', function() {
        const target = cta.getAttribute('href') || '';
        const ctaLocation = cta.getAttribute('data-eb-scroll-cta') || '';
        trackResultCta(cta, ctaLocation, target);
      });
    });
  }

  // Everbright offer-view — parity with Mighty's _bindViewContent, scoped to the
  // EB buy box (.eb-pdp) and the single EB SKU. Fires eb_offer_viewed (PostHog,
  // via the eb_ prefix in _capture) + Meta ViewContent + GA4 view_item once the
  // buy box crosses the viewport. This is the "how many saw the offer" number.
  let _ebVcFired = false;
  let _ebVcPixelFired = false;
  function _bindEbViewContent(root, routing) {
    if (_ebVcPixelFired) return;
    if (!('IntersectionObserver' in window)) return;
    const target = root.querySelector('.eb-pdp');
    if (!target) return;
    const variantId = (window.MQ_CONFIG && window.MQ_CONFIG.shopifyVariantId) || '';
    const value = EB_PLAN_PRICE.sub; // default plan selected when the offer enters view
    const obs = new IntersectionObserver(function(entries, io) {
      entries.forEach(function(e) {
        if (!e.isIntersecting) return;

        if (!_ebVcFired) {
          _ebVcFired = true;
          _capture('quiz_offer_viewed', Object.assign({
            event_id: _pixelMkEventId('eb-vc'),
            value: value,
          }, _ebAnalyticsPayload(routing)));
        }

        if (_ebVcPixelFired) return;
        if (!window.fbq) {
          io.unobserve(target);
          setTimeout(function() { if (!_ebVcPixelFired) io.observe(target); }, 250);
          return;
        }
        _ebVcPixelFired = true;
        io.disconnect();
        const eid = _pixelMkEventId('eb-vc');
        _fb('track', 'ViewContent', {
          content_ids: variantId ? [Number(variantId)] : [],
          content_type: 'product',
          content_name: 'Everbright — 5-in-1 Revival Stack',
          value: value,
          currency: 'USD',
        }, { eventID: eid });
        _gtag('event', 'view_item', {
          event_id: eid,
          currency: 'USD',
          value: value,
          items: variantId ? [{
            item_id: Number(variantId),
            item_name: 'Everbright — 5-in-1 Revival Stack',
            currency: 'USD',
          }] : [],
        });
      });
    }, { threshold: 0 });
    obs.observe(target);
  }

  function _bindEbResultSectionViews(root, routing) {
    if (!('IntersectionObserver' in window)) return;
    const ebProps = _ebAnalyticsPayload(routing);
    const sections = [
      ['profile', '.ebr-cprofile'],
      ['protocol', '.eb-pdp'],
      ['why_map', '.ebr-why'],
      ['mechanism', '.ebr-mech'],
      ['expect', '.ebr-expect'],
      ['founder', '.ebr-founder'],
      ['proof', '.eb-voices'],
      ['guarantee', '.ebr-guarantee'],
      ['faq', '.eb-faqs'],
      ['final_cta', '.eb-final-cta'],
    ];
    const seen = new Set();
    const obs = new IntersectionObserver(function(entries, io) {
      entries.forEach(function(entry) {
        if (!entry.isIntersecting) return;
        const sectionId = entry.target.getAttribute('data-eb-section-id');
        if (!sectionId || seen.has(sectionId)) return;
        seen.add(sectionId);
        io.unobserve(entry.target);
        const eid = _pixelMkEventId('eb-result-section');
        const props = Object.assign({
          section_id: sectionId,
          event_id: eid,
        }, ebProps);
        _capture('quiz_result_section_viewed', props);
        _fb('trackCustom', 'EB_ResultSectionView', Object.assign({ quiz_id: CFG.quizId }, props), { eventID: eid });
      });
    }, { threshold: 0 });
    sections.forEach(function(pair) {
      const sectionId = pair[0];
      const el = root.querySelector(pair[1]);
      if (!el || el.dataset.ebSectionObserved === '1') return;
      el.dataset.ebSectionObserved = '1';
      el.setAttribute('data-eb-section-id', sectionId);
      obs.observe(el);
    });
  }

  // ---------------------------------------------------------------------------
  // Everbright v3 result reveal — brings _eb_result_body.html.j2 to life.
  // Port of the reviewed launch mock (everbright-quiz-result-v1.html):
  // cellular profile, PDP offer (subscribe / one-time), answer→ingredient
  // map, goal-keyed personalization. Driven by routing (phase/signatures/
  // dose) + the raw answers — no URL params.
  // ---------------------------------------------------------------------------
  const EB_PLAN_PRICE = { sub: 39, onetime: 59 };
  // Same cart chains as the clubeverbright homepage buy box.
  const EB_CART_URLS = {
    sub: 'https://clubeverbright.com/cart/clear?return_to=/cart/add?items[][id]=43739752235062%26items[][quantity]=1%26items[][selling_plan]=2223702070%26return_to=/checkout',
    onetime: 'https://clubeverbright.com/cart/clear?return_to=/cart/add?items[][id]=43739752235062%26items[][quantity]=1%26return_to=/checkout?discount=TRY-BRIGHT',
  };

  const _EBR_PATTERN = {
    ST: 'the peak-reserve pattern — your cellular reserves are still full, and this is the window that compounds the longest',
    ES: 'the early perimenopause pattern — cycle, brain, and energy starting to shift together',
    DS: 'the mid-perimenopause pattern — where things compound, and where the right protocol moves fastest',
    PT: 'the menopause pattern — estrogen at its floor, the cellular cost compounding',
    PR: "the postpartum recovery pattern — a recoverable cellular cost, not 'just mom brain'",
  };

  const _EBR_GOALS = {
    BR: {
      name: 'Brain', goalWord: 'focus',
      subSymptoms: 'focus, recall, and word-finding',
      firstSignal: 'Sharper recall and fewer lost words in 2–4 weeks — your brain shifts first.',
      chips: ['Losing words mid-sentence', 'Foggy by afternoon', 'Slower than I remember'],
      protectChips: ['Keep recall sharp', 'Protect afternoon focus', 'Stay ahead of the fog'],
      protectYou: ['Keep recall sharp', 'Hold focus through the afternoon', 'Protect steady sleep'],
      map: [
        { you: 'Losing words mid-sentence', fix: '<b>Citicoline</b> rebuilds the acetylcholine pool your brain uses for recall and word-finding.' },
        { you: 'Foggy by afternoon', fix: '<b>Nicotinamide Riboside</b> restores the cellular NAD+ your neurons run on, so the fog has less to feed on.' },
        { you: 'Restless, broken sleep', fix: '<b>Restored NAD+</b> supports the day-night rhythm your cells run on, so nights hold steadier as levels rebuild.' },
      ],
    },
    EN: {
      name: 'Energy', goalWord: 'energy',
      subSymptoms: 'energy, focus, and sleep',
      firstSignal: 'Steadier afternoon energy in 2–3 weeks — without coffee, without the crash.',
      chips: ["Afternoon energy crash", "Coffee isn't covering it", 'Restless, broken sleep'],
      protectChips: ['Steady all-day energy', 'Head off the 3 PM dip', 'Stay ahead of the crash'],
      protectYou: ['Keep afternoons steady', 'Real energy, not another buzz', 'Protect deep sleep'],
      map: [
        { you: 'Afternoon energy crash', fix: '<b>Nicotinamide Riboside</b> rebuilds the cellular NAD+ your mitochondria run on — the molecule midlife burns off fastest.' },
        { you: "Coffee isn't covering it", fix: '<b>NR + citicoline</b> restore real cellular energy and focus — the spark, not another buzz that crashes.' },
        { you: 'Restless, broken sleep', fix: '<b>Restored NAD+</b> helps reset the cellular day-night rhythm behind broken sleep — the drain eases as levels come back.' },
      ],
    },
    RC: {
      name: 'Recovery', goalWord: 'recovery',
      subSymptoms: 'recovery, energy, and sleep',
      firstSignal: 'Faster bounce-back and less lingering fatigue in 3–5 weeks.',
      chips: ['Slower recovery', 'Joint stiffness, more aches', 'Workouts hit harder'],
      protectChips: ['Faster bounce-back', 'Protect joints & strength', 'Stay ahead of the aches'],
      protectYou: ['Keep recovery quick', 'Protect joints and connective tissue', 'Hold energy through training'],
      map: [
        { you: 'Slower recovery', fix: '<b>Pterostilbene</b> reaches the muscle and connective-tissue mitochondria where recovery actually happens — 4× more bioavailable than resveratrol.' },
        { you: 'Joint stiffness & aches', fix: '<b>Grape seed + astaxanthin</b> calm the oxidative stress that estrogen used to keep in check.' },
        { you: 'Afternoon energy crash', fix: '<b>Nicotinamide Riboside</b> restores the cellular NAD+ your muscles and brain both run on.' },
      ],
    },
    GL: {
      name: 'Glow', goalWord: 'glow',
      subSymptoms: 'skin, energy, and sleep',
      firstSignal: 'Visible resilience — texture and tone — over months 2–3 as antioxidant defense rebuilds.',
      chips: ['Skin not responding', 'Texture changing', 'Less glow than before'],
      protectChips: ['Keep skin resilient', 'Protect your glow', 'Stay ahead of dullness'],
      protectYou: ['Keep skin responsive', 'Protect texture and tone', 'Fuel cellular renewal'],
      map: [
        { you: 'Skin not responding', fix: '<b>Grape seed + astaxanthin</b> replace the photoprotection and microcirculation estradiol used to carry.' },
        { you: 'Texture & tone changing', fix: '<b>Antioxidant complex</b> backs up the cellular defense that fades when estrogen drops.' },
        { you: 'Afternoon energy crash', fix: '<b>Nicotinamide Riboside</b> restores the cellular NAD+ skin cells need to renew.' },
      ],
    },
  };

  // symptom → ingredient map — drives chips + the why-map from ACTUAL answers
  const _EBR_SYMPTOM_MAP = {
    fatigue: { label: 'Moderate-to-intense fatigue', icon: '🔋', fix: '<b>Nicotinamide Riboside</b> rebuilds the cellular NAD+ your energy runs on — the molecule midlife burns off fastest.' },
    fog: { label: 'Brain fog', icon: '🧠', fix: '<b>Citicoline</b> restores the acetylcholine your brain uses for focus and recall.' },
    concentrate: { label: 'Trouble concentrating', icon: '🎯', fix: '<b>Citicoline</b> supports the brain-fuel your focus and word-finding run on.' },
    motivation: { label: 'Low motivation', icon: '⚡', fix: '<b>Nicotinamide Riboside</b> refuels the cellular energy that flat, why-bother days run low on.' },
    crash: { label: 'Afternoon energy crashes', icon: '📉', fix: '<b>Nicotinamide Riboside</b> steadies the 3 PM dip by refueling your mitochondria at the source.' },
    sleep: { label: 'Restless sleep, waking tired', icon: '😴', fix: '<b>Grape seed + astaxanthin</b> calm the overnight oxidative stress that fragments deep sleep.' },
    skin: { label: 'Skin looking duller or older', icon: '✨', fix: '<b>Astaxanthin + grape seed</b> replace the antioxidant protection estrogen gave your skin.' },
    mood: { label: 'Mood more up-and-down', icon: '🌤️', fix: '<b>Pterostilbene + astaxanthin</b> buffer the oxidative stress estrogen loss leaves behind.' },
    recovery: { label: 'Slower recovery, more aches', icon: '🛡️', fix: '<b>Pterostilbene</b> reaches the muscle and connective-tissue mitochondria where recovery lives — 4× more bioavailable than resveratrol.' },
  };

  // tried → objection copy, keyed by ebObjectionKey()
  const _EBR_Q7 = {
    hrt: { eyebrow: "You've tried HRT", body: 'HRT replaces hormones; Everbright addresses what hormone shifts cost your cells. They work together — most of our perimenopause and menopause readers take both. NAD+ is the layer HRT alone doesn’t reach.' },
    multivitamin: { eyebrow: "You've tried a multivitamin", body: 'Most multivitamins miss NAD+ entirely. The cellular fuel layer underneath your B-complex is what you’ve been missing — and it’s the molecule midlife depletes fastest.' },
    adaptogens: { eyebrow: "You've tried adaptogens", body: 'Adaptogens help your stress response; Everbright addresses what stress depletes. Different mechanism, complementary.' },
    other_nad: { eyebrow: "You're already on NAD+", body: 'You’re in the right conversation — but plain NAD+ products were built for men or younger women. They miss the antioxidant layer that women after the hormone shift specifically need.' },
    nothing: { eyebrow: "You haven't tried anything yet", body: 'Start at the upstream layer. Most women begin with something narrow before realizing the cellular fuel layer is what’s actually depleted. That’s where the work compounds from.' },
    tried_everything: { eyebrow: "You've tried a lot, nothing held", body: 'NAD+ is the molecule under the layers everything else addresses. It’s why nothing held. Most readers in your situation describe Everbright as the piece that finally moved the floor — not just one symptom.' },
  };

  function _ebrClamp(v) { return Math.max(0, Math.min(1, v)); }

  // Cellular-profile scoring — drain % + four dimension bars, computed from
  // the real answers (same weights as the reviewed quiz mock).
  function _ebrProfile(answers) {
    const a = answers || {};
    const sym = _ebSymptoms(a);
    const has = function(k) { return sym.indexOf(k) !== -1; };
    const energyBad = a.energy && a.energy !== 'steady';
    const enerB = _ebrClamp(['fatigue', 'crash', 'sleep'].filter(has).length / 3 + (energyBad ? 0.34 : 0));
    const brainB = _ebrClamp(['fog', 'concentrate', 'motivation'].filter(has).length / 3);
    const antiB = _ebrClamp(['skin', 'mood'].filter(has).length / 2);
    const durMap = { recent: 0.2, '6_12': 0.45, year: 0.7, always: 0.9, proactive: 0.08 };
    const ageMap = { u40: 0.2, '40_49': 0.45, '50_59': 0.7, '60p': 0.85 };
    const cycMap = { regular: -0.1, postpartum: 0, peri: 0.15, meno: 0.3, postmeno: 0.3 };
    const durW = durMap[a.duration] != null ? durMap[a.duration] : 0.35;
    const ageW = ageMap[a.age] != null ? ageMap[a.age] : 0.4;
    const cycAdj = cycMap[a.cycle] != null ? cycMap[a.cycle] : 0;
    const cycB = _ebrClamp((ageW + cycAdj) / 1.05);
    const drain = Math.round(_ebrClamp(0.15 + sym.length * 0.08 + durW * 0.25 + ageW * 0.18) * 100);
    const dims = [1 - enerB, 1 - brainB, 1 - antiB, 1 - cycB].map(function(v) { return Math.round(v * 100); });
    return { drain: drain, dims: dims };
  }

  function _ebrMatchPct(routing, objectionKey) {
    let s = 88;
    const phase = routing.phase;
    if (phase === 'DS' || phase === 'PT' || phase === 'PR') s += 3;
    if (objectionKey === 'tried_everything' || objectionKey === 'other_nad' || objectionKey === 'hrt') s += 3;
    if (objectionKey === 'nothing') s += 1;
    s += 2; // goal-led signature always present
    return Math.min(97, Math.max(88, s));
  }

  function _ebrEsc(s) {
    return String(s).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;');
  }

  function _ebrSet(root, key, html) {
    root.querySelectorAll('[data-eb="' + key + '"]').forEach(function(el) { el.innerHTML = html; });
  }

  function _ebrRevealMapRows(root) {
    // Stagger only — the reveal itself is handled by the scroll-sweep in
    // _bindEbrSectionReveals (runs after render, so rows exist by then).
    root.querySelectorAll('.map-row').forEach(function(r, i) {
      r.style.transitionDelay = (i * 90) + 'ms';
    });
  }

  function _ebrStickyText(plan) {
    return plan === 'onetime'
      ? 'Everbright — One-time <small>$59 +$8 ship · 30-day money-back</small>'
      : 'Everbright — Subscribe &amp; Save <small>$39/mo · free shipping · cancel anytime</small>';
  }

  function _ebrApplyPlan(root) {
    const plan = state.ebPlan || 'sub';
    root.querySelectorAll('.opt').forEach(function(o) {
      o.classList.toggle('sel', o.getAttribute('data-plan') === plan);
    });
    _ebrSet(root, 'sticky-text', _ebrStickyText(plan));
    const atc = root.querySelector('.pdp-atc');
    if (atc) atc.setAttribute('href', EB_CART_URLS[plan]);
  }

  function renderEbResultV3(root, routing, answers) {
    const a = answers || {};
    const cfg = window.MQ_CONFIG || {};
    const topSig = (routing.signatures || [])[0] || 'EN';
    const goal = _EBR_GOALS[topSig] || _EBR_GOALS.EN;
    const pattern = _EBR_PATTERN[routing.phase] || _EBR_PATTERN.ES;
    const firstName = ((state.email_gate && state.email_gate.first_name) || state.firstName || '').trim();

    root.setAttribute('data-phase', routing.phase || '');
    root.setAttribute('data-sig', topSig);
    root.setAttribute('data-dose', routing.dose || 'F');

    // ---- cellular profile
    const prof = _ebrProfile(a);
    const drain = prof.drain;
    const band = drain >= 75 ? 'High' : drain >= 50 ? 'Medium' : drain >= 25 ? 'Normal' : 'Low';
    _ebrSet(root, 'cp-h2', (firstName ? _ebrEsc(firstName) + ' — Your' : 'Your') + ' Energy Reset Profile');
    _ebrSet(root, 'cp-band', (drain >= 50 ? '⚠️ ' : '') + band.toUpperCase());
    root.querySelectorAll('[data-eb="cp-band"]').forEach(function(b) {
      b.style.color = drain >= 50 ? 'var(--red)' : drain >= 25 ? 'var(--star)' : 'var(--green)';
    });
    root.querySelectorAll('[data-eb="cp-tip"]').forEach(function(t) {
      t.style.left = drain + '%';
      t.textContent = 'You — ' + drain + '%';
    });
    root.querySelectorAll('[data-eb="cp-you"]').forEach(function(y) { y.style.left = drain + '%'; });
    const dimNames = ['Cellular energy', 'Focus & clarity', 'Antioxidant defense', 'Hormonal transition'];
    _ebrSet(root, 'cp-dims', prof.dims.map(function(v, i) {
      const rt = v >= 66 ? ['GOOD', 'var(--green)'] : v >= 40 ? ['FAIR', 'var(--star)'] : ['LOW', 'var(--red)'];
      return '<div class="cp-dim"><div class="cp-top2"><span class="cp-nm">' + dimNames[i] + '</span>' +
             '<span class="cp-rt" style="color:' + rt[1] + '">' + rt[0] + '</span></div>' +
             '<div class="cp-track"><i style="width:' + v + '%;background:' + rt[1] + '"></i></div></div>';
    }).join(''));

    // ---- pdp head + CTA wording, keyed by the GOAL answer (the result
    //      track stays signature-led; the words follow what they asked for)
    const goalWording = ({
      energy: { reading: 'for maximum energy', cta: 'Get my energy back →' },
      focus: { reading: 'for maximum focus', cta: 'Get my focus back →' },
      glow: { reading: 'for maximum glow', cta: 'Get my glow back →' },
      recovery: { reading: 'for maximum recovery', cta: 'Get my strength back →' },
    })[String(a.goal || '')] || { reading: 'for longevity', cta: 'Stay ahead of aging →' };
    _ebrSet(root, 'reading', 'Recommended ' + goalWording.reading);

    // ---- matched chips + why-map from the ACTUAL flagged symptoms.
    //      When nothing is flagged ("None of these" / proactive), don't
    //      fabricate symptoms under a "matched to your answers" label —
    //      reframe the section as goal-led / stay-ahead (mirrors the
    //      interstitial's proactive copy). See _ebIntRecap().
    const flagged = _ebSymptoms(a).filter(function(k) { return _EBR_SYMPTOM_MAP[k]; });
    const noSym = flagged.length === 0;

    _ebrSet(root, 'hero-sub', noSym
      ? "Nothing feels off yet — and that's the window that matters most. Everbright is built to protect <em>" +
          _ebrEsc(goal.subSymptoms) + '</em> before the shift reaches them.'
      : 'Your answers point to ' + _ebrEsc(pattern) + ' — <em>' + _ebrEsc(goal.subSymptoms) +
          "</em> slipping together. That's a cellular-energy signal, and this is built for exactly that.");

    _ebrSet(root, 'matched-lbl', noSym ? 'Matched to your goal' : 'Matched to your answers');
    _ebrSet(root, 'match-tagline', noSym
      ? '<b>Built around your goal</b>You told us nothing feels off yet — this is the layer that keeps it that way.'
      : '<b>Strong match to your answers</b>Based on your stage, your goal, and what you’ve already tried.');

    _ebrSet(root, 'matched-chips', (noSym
      ? (goal.protectChips || goal.chips).map(function(c) { return '<span class="chip">' + _ebrEsc(c) + '</span>'; })
      : flagged.slice(0, 4).map(function(k) { return '<span class="chip">' + _ebrEsc(_EBR_SYMPTOM_MAP[k].label) + '</span>'; })).join(''));

    const objection = ebObjectionKey(a);
    const pct = _ebrMatchPct(routing, objection);
    _ebrSet(root, 'match-pct', pct + '%');
    root.querySelectorAll('[data-eb-match-ring]').forEach(function(r) { r.style.setProperty('--p', pct); });

    // ---- lead ingredient (copy shipped from the YAML via MQ_CONFIG)
    const leadH3 = (cfg.signatureLeadIngredientH3 || {})[topSig] || '';
    const leadBody = (cfg.signatureLeadIngredientBody || {})[topSig] || '';
    _ebrSet(root, 'lead-h3', _ebrEsc(leadH3));
    _ebrSet(root, 'lead-body', _ebrEsc(leadBody));

    _ebrSet(root, 'why-h2', noSym ? 'How Everbright keeps you ahead' : 'How Everbright meets what you told us');
    _ebrSet(root, 'map', (noSym
      ? goal.map.map(function(m, i) {
          const you = (goal.protectYou && goal.protectYou[i]) || m.you;
          return '<div class="map-row"><div class="you">' + _ebrEsc(you) + '</div>' +
                 '<div class="arr">→</div><div class="fix">' + m.fix + '</div></div>';
        })
      : flagged.slice(0, 5).map(function(k) {
          const m = _EBR_SYMPTOM_MAP[k];
          return '<div class="map-row"><div class="you"><span class="mi">' + m.icon + '</span>' + _ebrEsc(m.label) + '</div>' +
                 '<div class="arr">→</div><div class="fix">' + m.fix + '</div></div>';
        })).join(''));
    _ebrRevealMapRows(root);

    _ebrSet(root, 'first-signal', _ebrEsc(goal.firstSignal));

    // ---- offer + CTAs
    if (!state.ebPlan) state.ebPlan = 'sub';
    _ebrSet(root, 'cta-text', goalWording.cta);
    _ebrApplyPlan(root);

    // ---- q7 objection → FAQ entry
    const q = _EBR_Q7[objection];
    const faq = root.querySelector('[data-eb="q7-faq"]');
    if (faq) {
      if (q) {
        faq.hidden = false;
        _ebrSet(root, 'q7-faq-q', _ebrEsc(q.eyebrow) + ' — does this still fit?');
        _ebrSet(root, 'q7-faq-a', _ebrEsc(q.body));
      } else {
        faq.hidden = true;
      }
    }

    _ebrSet(root, 'final-h2', firstName ? 'Your protocol is ready, ' + _ebrEsc(firstName) + '.' : 'Your protocol is ready.');
  }

  function _bindEbrPlanToggle(root) {
    root.querySelectorAll('.opt').forEach(function(o) {
      if (o.dataset.ebrPlanBound === '1') return;
      o.dataset.ebrPlanBound = '1';
      o.addEventListener('click', function() {
        state.ebPlan = o.getAttribute('data-plan') || 'sub';
        _ebrApplyPlan(root);
      });
    });
  }

  // PDP gallery — thumbnails swap the main image / play the video slides.
  function _bindEbrGallery(root) {
    const mainImg = root.querySelector('#pdpMainImg');
    const mainVid = root.querySelector('#pdpMainVid');
    const mainSplit = root.querySelector('#pdpMainSplit');
    const splitVid = root.querySelector('#pdpSplitVid');
    const thumbs = [].slice.call(root.querySelectorAll('.pdp-thumb'));
    const capEl = root.querySelector('#pdpCaption');
    const badgeEl = root.querySelector('#pdpBadge');
    if (!mainImg || !thumbs.length || mainImg.dataset.ebrGalleryBound === '1') return;
    mainImg.dataset.ebrGalleryBound = '1';
    function hideAll() {
      if (mainVid) { mainVid.pause(); mainVid.style.display = 'none'; }
      if (mainSplit) { if (splitVid) splitVid.pause(); mainSplit.style.display = 'none'; }
      mainImg.style.display = 'none';
    }
    function setOverlays(t) {
      if (capEl) {
        const cap = t.getAttribute('data-caption');
        const head = t.getAttribute('data-cap-head');
        if (cap || head) {
          const quote = t.getAttribute('data-cap-type') === 'quote';
          capEl.className = 'pdp-caption ' + (quote ? 'cap-quote' : 'cap-title') + ' ' + (t.getAttribute('data-cap-align') || 'center');
          capEl.innerHTML = '';
          if (head) {
            const h = document.createElement('div'); h.className = 'cap-head'; h.textContent = '“' + head; capEl.appendChild(h);
            const body = document.createElement('div'); body.className = 'cap-body';
            const pre = t.getAttribute('data-cap-body'); if (pre) body.appendChild(document.createTextNode(pre));
            const hl = t.getAttribute('data-cap-hl');
            if (hl) { const mk = document.createElement('span'); mk.className = 'cap-hl'; mk.textContent = hl; body.appendChild(mk); }
            const tail = t.getAttribute('data-cap-tail'); if (tail) body.appendChild(document.createTextNode(tail));
            body.appendChild(document.createTextNode('”'));
            capEl.appendChild(body);
          } else {
            const m = document.createElement('div'); m.className = 'cap-main';
            m.textContent = quote ? '“' + cap + '”' : cap;
            capEl.appendChild(m);
          }
          const by = t.getAttribute('data-cap-by');
          if (by) { const b = document.createElement('div'); b.className = 'cap-by'; b.textContent = by; capEl.appendChild(b); }
          capEl.style.display = 'flex';
        } else { capEl.style.display = 'none'; }
      }
      if (badgeEl) {
        const bd = t.getAttribute('data-badge');
        if (bd) {
          badgeEl.innerHTML = '';
          bd.split('|').forEach(function(line) {
            const s = document.createElement('div');
            s.className = 'b-line';
            s.textContent = line;
            badgeEl.appendChild(s);
          });
          badgeEl.style.display = 'flex';
        } else { badgeEl.style.display = 'none'; }
      }
    }
    let current = 0;
    function activate(t) {
      thumbs.forEach(function(o) { o.classList.toggle('sel', o === t); });
      setOverlays(t);
      const type = t.getAttribute('data-type');
      if (type === 'split' && mainSplit) {
        hideAll();
        mainSplit.style.display = 'grid';
        if (splitVid) splitVid.play();
      } else if (type === 'video' && mainVid) {
        hideAll();
        const vsrc = t.getAttribute('data-vid');
        if (vsrc && mainVid.getAttribute('src') !== vsrc) {
          mainVid.setAttribute('src', vsrc);
          mainVid.setAttribute('poster', t.getAttribute('data-poster') || '');
          mainVid.load();
        }
        mainVid.style.display = 'block';
        mainVid.play();
      } else {
        hideAll();
        const cover = t.getAttribute('data-fit') === 'cover';
        const srcEl = t.tagName === 'IMG' ? t : t.querySelector('img');
        mainImg.style.display = 'block';
        mainImg.src = t.getAttribute('data-src') || (srcEl ? srcEl.src : t.src);
        mainImg.alt = (srcEl && srcEl.alt) || mainImg.alt;
        mainImg.style.objectFit = cover ? 'cover' : 'contain';
        mainImg.style.padding = cover ? '0' : '1rem';
      }
    }
    function goTo(i) {
      current = ((i % thumbs.length) + thumbs.length) % thumbs.length;
      activate(thumbs[current]);
    }
    thumbs.forEach(function(t, i) {
      t.addEventListener('click', function() { current = i; activate(t); });
    });
    const prevBtn = root.querySelector('#pdpPrev');
    const nextBtn = root.querySelector('#pdpNext');
    if (prevBtn) prevBtn.addEventListener('click', function() { goTo(current - 1); });
    if (nextBtn) nextBtn.addEventListener('click', function() { goTo(current + 1); });
    const mainEl = root.querySelector('.pdp-main');
    if (mainEl) {
      let sx = 0, sy = 0, swiping = false;
      mainEl.addEventListener('touchstart', function(e) {
        const p = e.changedTouches[0]; sx = p.clientX; sy = p.clientY; swiping = true;
      }, { passive: true });
      mainEl.addEventListener('touchend', function(e) {
        if (!swiping) return; swiping = false;
        const p = e.changedTouches[0], dx = p.clientX - sx, dy = p.clientY - sy;
        if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy)) goTo(dx < 0 ? current + 1 : current - 1);
      }, { passive: true });
      mainEl.setAttribute('tabindex', '0');
      mainEl.addEventListener('keydown', function(e) {
        if (e.key === 'ArrowLeft') { goTo(current - 1); e.preventDefault(); }
        else if (e.key === 'ArrowRight') { goTo(current + 1); e.preventDefault(); }
      });
    }
    // miniature previews inside caption/badge thumbnails
    thumbs.forEach(function(t) {
      const head = t.getAttribute('data-cap-head');
      const cap = t.getAttribute('data-caption');
      if (head || cap) {
        const quote = t.getAttribute('data-cap-type') === 'quote';
        const p = document.createElement('span');
        p.className = 'tprev ' + (t.getAttribute('data-cap-align') || 'center');
        if (head) {
          const h = document.createElement('span'); h.className = 'tp-head'; h.textContent = '“' + head; p.appendChild(h);
          const b = document.createElement('span'); b.className = 'tp-body';
          const pre = t.getAttribute('data-cap-body'); if (pre) b.appendChild(document.createTextNode(pre));
          const hl = t.getAttribute('data-cap-hl');
          if (hl) { const mk = document.createElement('span'); mk.className = 'tp-hl'; mk.textContent = hl; b.appendChild(mk); }
          const tail = t.getAttribute('data-cap-tail'); if (tail) b.appendChild(document.createTextNode(tail));
          b.appendChild(document.createTextNode('”'));
          p.appendChild(b);
        } else {
          const m = document.createElement('span'); m.className = 'tp-main'; m.textContent = quote ? '“' + cap + '”' : cap; p.appendChild(m);
        }
        t.appendChild(p);
      }
      const bd = t.getAttribute('data-badge');
      if (bd) {
        const c = document.createElement('span'); c.className = 'tprev-badge';
        bd.split('|').forEach(function(line) { const s = document.createElement('span'); s.className = 'tb-line'; s.textContent = line; c.appendChild(s); });
        t.appendChild(c);
      }
    });
    const info = root.querySelector('.pdp-split-info');
    const panel = root.querySelector('.pdp-thumb-split .mini-panel');
    if (info && panel) {
      panel.innerHTML = '';
      const eb = info.querySelector('.pdp-split-eyebrow');
      if (eb) { const e = document.createElement('span'); e.className = 'tp-eyebrow'; e.textContent = eb.textContent; panel.appendChild(e); }
      [].slice.call(info.querySelectorAll('li')).forEach(function(li) { const s = document.createElement('span'); s.className = 'tp-benefit'; s.textContent = li.textContent; panel.appendChild(s); });
    }
  }

  function _bindEbrUgc(root) {
    const modal = root.querySelector('[data-eb-ugc-modal]');
    const vid = root.querySelector('[data-eb-ugc-video]');
    const closeB = root.querySelector('[data-eb-ugc-close]');
    if (!modal || modal.dataset.ebrUgcBound === '1') return;
    modal.dataset.ebrUgcBound = '1';
    function openUgc(src) { vid.src = src; modal.classList.add('open'); vid.play(); document.body.style.overflow = 'hidden'; }
    function closeUgc() { vid.pause(); vid.removeAttribute('src'); vid.load(); modal.classList.remove('open'); document.body.style.overflow = ''; }
    root.querySelectorAll('.ugc-card').forEach(function(c) {
      c.addEventListener('click', function() { openUgc(c.getAttribute('data-vdo')); });
    });
    if (closeB) closeB.addEventListener('click', closeUgc);
    modal.addEventListener('click', function(e) { if (e.target === modal) closeUgc(); });
    document.addEventListener('keydown', function(e) { if (e.key === 'Escape' && modal.classList.contains('open')) closeUgc(); });
  }

  // Sticky buybar — shows once the in-page ATC scrolls out above. Scroll-
  // driven (not IO): an instant jump past the ATC produces no intersection
  // change, so an observer can miss it entirely.
  function _bindEbrSticky(root) {
    const atc = root.querySelector('.pdp-atc');
    const bar = root.querySelector('[data-eb-sticky]');
    if (!atc || !bar || bar.dataset.ebrStickyBound === '1') return;
    bar.dataset.ebrStickyBound = '1';
    let ticking = false;
    function update() {
      ticking = false;
      bar.classList.toggle('show', atc.getBoundingClientRect().bottom < 0);
    }
    function onScroll() {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(update);
    }
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll, { passive: true });
    update();
  }

  // Sections + map rows fade up as they enter view. Scroll-sweep, NOT an
  // IntersectionObserver: an instant jump (anchor click, scrollIntoView,
  // fast fling) can move an element from below the viewport to above it
  // with no intersection change — IO never fires and the element would
  // stay invisible. The sweep reveals anything at or above the viewport
  // line on every (rAF-throttled) scroll. The .ebr-animate gate keeps the
  // page fully visible when JS is unavailable.
  function _bindEbrSectionReveals(root) {
    const targets = [].slice.call(
      root.querySelectorAll('section > .wrap, section > .wrap-p, .map-row')
    );
    if (!targets.length) return;
    root.classList.add('ebr-animate');
    let pending = targets.slice();
    let ticking = false;
    function sweep() {
      ticking = false;
      const limit = window.innerHeight * 0.96;
      pending = pending.filter(function(t) {
        if (t.getBoundingClientRect().top <= limit) {
          t.classList.add('in');
          return false;
        }
        return true;
      });
      if (!pending.length) {
        window.removeEventListener('scroll', onScroll);
        window.removeEventListener('resize', onScroll);
      }
    }
    function onScroll() {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(sweep);
    }
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll, { passive: true });
    sweep();
  }

  // In-page CTAs (#offer anchors) glide instead of jumping — replaces the
  // mock's html { scroll-behavior: smooth }, which can't be scoped.
  function _bindEbrSmoothScroll(root) {
    root.querySelectorAll('[data-eb-scroll-cta]').forEach(function(cta) {
      if (cta.dataset.ebrScrollBound === '1') return;
      cta.dataset.ebrScrollBound = '1';
      cta.addEventListener('click', function(e) {
        const href = cta.getAttribute('href') || '';
        if (href.charAt(0) !== '#') return;
        const target = root.querySelector(href);
        if (!target) return;
        e.preventDefault();
        target.scrollIntoView({ behavior: 'smooth', block: 'start' });
      });
    });
  }

  // Entry point — called from revealResult() for the EB quiz.
  function revealResultEverbright(routing, answers) {
    const root = document.querySelector('[data-eb-root]') ||
                 document.querySelector('.mq__stage--result') || document.body;
    if (!root) return;
    // Shareable/reloadable URL — parity with the Mighty reveal path. `?r=` is
    // an opaque AES-GCM token only; never answer keys or condition signals.
    if (state.resultToken) {
      history.replaceState(null, '', '?r=' + encodeURIComponent(state.resultToken));
    } else {
      history.replaceState(null, '', location.pathname);
    }
    renderEbResultV3(root, routing, answers);
    _bindEbrPlanToggle(root);
    _bindEbrGallery(root);
    _bindEbrUgc(root);
    _bindEbrSticky(root);
    _bindEbrSectionReveals(root);
    _bindEbrSmoothScroll(root);
    _bindEbResultCtas(root, routing, EB_CART_URLS[state.ebPlan || 'sub']);
    _bindEbResultSectionViews(root, routing);
    _bindEbViewContent(root, routing);
  }

  // ---------- Routing (mirrors backend/src/athena/cli/quiz/routing.py)
  // Test cases live in backend/tests/cli/quiz/test_routing.py — that file
  // is the canonical contract. Any change here must keep those passing.
  const RX_TRIGGERS = new Set(['rx_preventive', 'botox', 'triptan']);
  const STACKER_TRIGGERS = new Set(['supplement_formula', 'single_ingredients', 'stacking_5_plus']);
  const LOW_INTERVENTION = new Set(['nothing', 'otc', 'lifestyle']);
  const HIGH_FREQ = new Set(['frequent', 'constant']);
  const DIDNT_WORK = new Set(['no_diff', 'worked_stopped', 'helped_little']);

  function intersects(setA, listB) {
    for (const v of listB || []) if (setA.has(v)) return true;
    return false;
  }
  function isSubset(listA, setB) {
    for (const v of listA || []) if (!setB.has(v)) return false;
    return true;
  }

  // -----------------------------------------------------------------------
  // Everbright quiz v3 routing — mirror of
  // backend/src/athena/cli/quiz/routing_everbright.py
  // Tests in backend/tests/cli/quiz/test_routing_everbright.py are the contract.
  // -----------------------------------------------------------------------
  const _EB_PHASE_ORDER = ['ST', 'ES', 'DS', 'PT'];
  const _EB_CYCLE_PHASE_MAP = {
    regular: 'ST', postpartum: 'PR', peri: 'ES', meno: 'PT', postmeno: 'PT'
  };
  const _EB_AGE_FALLBACK_PHASE = { u40: 'ST', '40_49': 'ES', '50_59': 'DS', '60p': 'PT' };
  const _EB_BUMP_DURATIONS = new Set(['year', 'always']);
  const _EB_BUMP_SYMPTOM_COUNT = 5;
  const _EB_ENERGY_SYMPTOMS = new Set(['fatigue', 'crash', 'sleep']);
  const _EB_BRAIN_SYMPTOMS = new Set(['fog', 'concentrate', 'motivation']);
  const _EB_ENERGY_ANSWER_SCORE = { pm: 2, am: 2, swing: 1, steady: 0 };
  const _EB_AGE_GLOW = { '50_59': 1, '60p': 2 };
  const _EB_GOAL_SIGNATURE = { energy: 'EN', focus: 'BR', glow: 'GL', recovery: 'RC' };
  const _EB_SIG_THRESHOLD = 2;
  const _EB_SIG_ORDER = ['BR', 'EN', 'RC', 'GL'];

  function _ebSymptoms(answers) {
    const raw = Array.isArray(answers.symptoms) ? answers.symptoms : [];
    return raw.filter(s => typeof s === 'string' && s !== 'none');
  }

  function _ebPhaseFromCycle(cycle, age) {
    if (_EB_CYCLE_PHASE_MAP[cycle]) return _EB_CYCLE_PHASE_MAP[cycle];
    return _EB_AGE_FALLBACK_PHASE[age] || 'ST';
  }

  function _ebApplyBump(phase, duration, symptoms) {
    if (!_EB_PHASE_ORDER.includes(phase)) return phase;
    if (!_EB_BUMP_DURATIONS.has(duration) && symptoms.length < _EB_BUMP_SYMPTOM_COUNT) return phase;
    const idx = _EB_PHASE_ORDER.indexOf(phase);
    return _EB_PHASE_ORDER[Math.min(idx + 1, _EB_PHASE_ORDER.length - 1)];
  }

  function _ebScoreSignatures(answers, age, symptoms) {
    const energyAnswer = String(answers.energy || '');
    return {
      BR: symptoms.filter(s => _EB_BRAIN_SYMPTOMS.has(s)).length,
      EN: symptoms.filter(s => _EB_ENERGY_SYMPTOMS.has(s)).length
        + (_EB_ENERGY_ANSWER_SCORE[energyAnswer] || 0),
      RC: symptoms.includes('recovery') ? 2 : 0,
      GL: (symptoms.includes('skin') ? 2 : 0)
        + (symptoms.includes('mood') ? 1 : 0)
        + (_EB_AGE_GLOW[age] || 0),
    };
  }

  function _ebTopScored(scores) {
    let best = 0;
    for (const c of _EB_SIG_ORDER) best = Math.max(best, scores[c]);
    if (best === 0) return 'EN';
    return _EB_SIG_ORDER.find(c => scores[c] === best);
  }

  function _ebSignatures(answers, age, symptoms) {
    const scores = _ebScoreSignatures(answers, age, symptoms);
    const lead = _EB_GOAL_SIGNATURE[String(answers.goal || '')] || _ebTopScored(scores);
    const secondaries = _EB_SIG_ORDER.filter(
      c => c !== lead && scores[c] >= _EB_SIG_THRESHOLD
    );
    return [lead].concat(secondaries);
  }

  function _ebDoseTier(phase, signatures, duration) {
    if (duration === 'proactive') return 'F';
    if (phase === 'DS' || phase === 'PT') return 'A';
    if ((phase === 'ES' || phase === 'PR') && signatures.length >= 2) return 'A';
    return 'F';
  }

  // tried (multi) → single objection-paragraph key. Keys match the result
  // page's data-show-q7 variants. Mirror of objection_key_everbright().
  function ebObjectionKey(answers) {
    const tried = Array.isArray(answers.tried) ? answers.tried : [];
    if (tried.includes('hrt')) return 'hrt';
    if (tried.includes('nad')) return 'other_nad';
    if (tried.includes('adaptogens')) return 'adaptogens';
    if (tried.includes('collagen') || tried.includes('greens')) return 'multivitamin';
    if (tried.filter(t => t !== 'nothing').length >= 3) return 'tried_everything';
    return 'nothing';
  }

  function computeRoutingEverbright(answers) {
    const a = answers || {};
    const age = String(a.age || '');
    const symptoms = _ebSymptoms(a);
    const duration = String(a.duration || '');
    const basePhase = _ebPhaseFromCycle(String(a.cycle || ''), age);
    const phase = _ebApplyBump(basePhase, duration, symptoms);
    const signatures = _ebSignatures(a, age, symptoms);
    const dose = _ebDoseTier(phase, signatures, duration);
    return { phase, signatures, dose, age_band: age };
  }

  function computeRouting(answers) {
    // EB V2 dispatch: route to computeRoutingEverbright and pass through the V2
    // routing object directly. Downstream EB-only call sites use routing.phase /
    // routing.signatures / routing.dose; the legacy {variant, modifiers} shape
    // is no longer produced for EB.
    if (_isEverbrightQuiz()) {
      return computeRoutingEverbright(answers);
    }

    // Dizzy: no archetype routing — one variant, no result page. Keeps the
    // Mighty axis logic below from reading answer ids that don't exist.
    if (window.MQ_CONFIG && window.MQ_CONFIG.quizId === 'mighty-dizzy-v1') {
      return { variant: 'dizzy', modifiers: [] };
    }

    // Safety gate (Axis 0) — q8_v1="yes" overrides everything.
    // Mirrors backend/src/athena/cli/quiz/routing.py.
    if (answers.q8_v1 === 'yes') {
      return { variant: 'not_recommended', modifiers: [] };
    }

    const q5 = answers.q5_v1 || '';
    const q6 = answers.q6_v1 || [];
    const q7 = answers.q7_v1 || '';
    let variant;
    if (intersects(RX_TRIGGERS, q6)) variant = 'rx_aware';
    else if (intersects(STACKER_TRIGGERS, q6)) variant = 'stacker';
    else variant = 'otc_reliant';

    const modifiers = [];
    if (q7 === 'side_effects') modifiers.push('sensitive_stomach');
    if (HIGH_FREQ.has(q5) && q6.length >= 3 && DIDNT_WORK.has(q7)) modifiers.push('tried_everything');
    if (q5 === 'new' && isSubset(q6, LOW_INTERVENTION) && q7 === 'havent_tried_much') modifiers.push('first_time');

    return { variant: variant, modifiers: modifiers };
  }

  // ============================================================
  // Personalization constants (Items 2-23). Top-level so they
  // don't get re-allocated on every render.
  // ============================================================

  // Item 16 — hero modifier band copy. Priority order matters.
  // (tried_everything 'Founder note' removed 2026-07-03 per Laila — it sat
  // between the match card and the buy box and broke the flow.)
  const _MOD_BAND_PRIORITY = ['sensitive_stomach', 'first_time'];
  const _MOD_BAND_COPY = {
    sensitive_stomach: '<strong>Heads up</strong> — you mentioned past supplements upset your stomach. Mighty\u2019s magnesium glycinate is the gentlest form on the gut. Start with 2 capsules/day with food and ramp up over a week.',
    first_time:        '<strong>Since this is your first daily migraine supplement:</strong> most people don\u2019t see the full effect until weeks 8-12. Track your migraine days to see the trend.',
  };

  // Item 23 — cohort counts (refreshed quarterly in real life).
  const _COHORT_COUNTS = {
    cycle: 89, chronic: 124, rx: 67, stack: 142, new_dx: 31, default: 84,
  };

  // Item 4 — compare-row scoring: same shape as _ING_TAG_RULES,
  // but every match adds to a score (not first-match-wins).
  const _COMPARE_RULES = {
    mag: [
      { key: 'q4_v1', val: 'sleep',    pts: 3 },
      { key: 'q4_v1', val: 'stress',   pts: 3 },
      { key: 'q4_v1', val: 'hormonal', pts: 2 },
      { key: 'q5_v1',  val: ['frequent', 'constant'], pts: 2 },
    ],
    b2: [
      { key: 'q5_v1',  val: ['frequent', 'constant'], pts: 3 },
      { key: 'q3_v1', val: 'brain_fog', pts: 1 },
    ],
    coq: [
      { key: 'q3_v1', val: 'brain_fog', pts: 3 },
      { key: 'q5_v1',  val: ['frequent', 'constant'], pts: 2 },
    ],
    feverfew: [
      { key: 'q3_v1', val: 'throbbing', pts: 3 },
      { key: 'q3_v1', val: 'light',     pts: 2 },
      { key: 'q3_v1', val: 'sound',     pts: 2 },
    ],
    methyl: [
      { key: 'q4_v1', val: 'hormonal',  pts: 3 },
      { key: 'q3_v1', val: 'aura',      pts: 3 },
    ],
    d3: [
      { key: 'q4_v1', val: 'weather',   pts: 3 },
    ],
  };

  // Item 15 — founder scale phrase by q5 pattern.
  const _FOUNDER_SCALE_PHRASE = {
    constant:      '15+ migraine days a month',
    frequent:      '2-3 migraine days a week',
    few_per_month: 'multiple attacks a month',
    few_per_year:  'a few attacks a year',
    new:           "brand-new attacks I couldn't predict",
  };

  // Item 10 — before/after calendar day-counts by q5 pattern.
  const _BA_BEFORE_DAYS = {
    constant: 15, frequent: 8, few_per_month: 4, few_per_year: 2, new: 3,
  };
  const _BA_AFTER_DAYS = {
    constant: 5, frequent: 3, few_per_month: 1, few_per_year: 1, new: 1,
  };
  // Pseudo-deterministic position rotation. Pick first N from list per pattern.
  const _BA_BEFORE_POSITIONS = [
    1,3,4,8,11,14,17,18,22,24,26,5,7,12,19,21,23,25,9,15,
  ];
  const _BA_AFTER_POSITIONS = [12,5,21,8,17];

  // Projection readout text by q5 pattern. Generic phrasing — no specific
  // numeric ranges — so it fits every respondent without overclaiming.
  const _PROJ_READOUT = {
    constant:      { h2_lede: 'Near-constant attacks now.',  h2_em: 'A different baseline by Day 90.',
                     today: 'near-constant',                 future: 'your target trajectory' },
    frequent:      { h2_lede: 'Frequent attacks now.',       h2_em: 'A different baseline by Day 90.',
                     today: 'frequent',                      future: 'your target trajectory' },
    few_per_month: { h2_lede: 'A few attacks a month now.',  h2_em: 'A steadier rhythm by Day 90.',
                     today: 'a few/month',                   future: 'your projected pattern' },
    few_per_year:  { h2_lede: 'Occasional attacks now.',     h2_em: 'More steady months by Day 90.',
                     today: 'occasional',                    future: 'your projected pattern' },
    new:           { h2_lede: 'Still figuring out your pattern.', h2_em: 'More clarity by Day 90.',
                     today: 'figuring it out',                future: 'a clearer baseline' },
  };

  // ============================================================
  // Personalization helpers
  // ============================================================

  // Item 2 — hero subhead = answer mirror via buildPatternSummary.
  function renderHeroSub(answers) {
    const txt = buildPatternSummary(answers);
    if (!txt) return;  // guard: leave static fallback
    const el = ROOT.querySelector('[data-mq-hero-sub]');
    if (el) el.textContent = txt;
  }

  // Item 4 — compare-row emphasis.
  function personalizeCompareEmphasis(answers) {
    // Idempotent — clear previous state.
    ROOT.querySelectorAll('[data-mq-compare-row]').forEach((row) => {
      row.querySelectorAll('[data-mq-compare-emphasis]').forEach((s) => { s.hidden = true; });
      row.querySelectorAll('.why-compare-line--matters').forEach((l) => l.classList.remove('why-compare-line--matters'));
      row.querySelectorAll('.why-compare-line--good .why-compare-text strong').forEach((s) => { s.style.fontWeight = ''; });
    });
    // Score each ingredient that has a row.
    const scores = [];
    ROOT.querySelectorAll('[data-mq-compare-row]').forEach((row) => {
      const ing = row.getAttribute('data-mq-compare-row');
      const rules = _COMPARE_RULES[ing] || [];
      let s = 0;
      for (const r of rules) {
        if (_matchesRule(r, answers)) s += r.pts || 1;
      }
      scores.push({ ing: ing, score: s, row: row });
    });
    scores.sort((a, b) => b.score - a.score);
    const top = scores.filter((x) => x.score > 0).slice(0, 2);
    top.forEach((entry) => {
      const goodLine = entry.row.querySelector('.why-compare-line--good');
      if (goodLine) {
        goodLine.classList.add('why-compare-line--matters');
        const emph = goodLine.querySelector('[data-mq-compare-emphasis]');
        if (emph) emph.hidden = false;
        const strongEl = goodLine.querySelector('.why-compare-text strong');
        if (strongEl) strongEl.style.fontWeight = '800';
      }
    });
    return top.map((x) => x.ing);
  }

  // Item 9 — pick reviews (variant + trigger group).
  function _topTriggerGroup(answers) {
    // 'cycle' is gated on female+hormonal — the cycle reviews are written
    // as menstrual-cycle narratives, which read wrong for a male respondent
    // who happened to pick 'hormonal'. Male users with hormonal fall through
    // to the chronic/general buckets.
    const triggers = answers.q4_v1 || [];
    const sex = answers.q1_v1;
    if (triggers.indexOf('hormonal') !== -1 && sex !== 'male') return 'cycle';
    const p = answers.q5_v1;
    if (p === 'frequent' || p === 'constant') return 'chronic';
    return 'general';
  }
  function pickReviews(answers, variant) {
    // Reveal 2 group-matched review-cards under the always-on feat-review,
    // for a total of 3 visible cards per archetype — matches the prototype's
    // people-section density (1 hero photo + 2 supporting reviews).
    const REVEAL_N = 2;
    // Scope to the people section so we don't pick up the why-for-you
    // variant block (which has no review cards inside it).
    const block = ROOT.querySelector('.people [data-show-variant="' + variant + '"]');
    if (!block) return { group: 'general', count: 0 };
    let group = _topTriggerGroup(answers);
    let cards = block.querySelectorAll('[data-mq-review][data-trigger="' + group + '"]');
    if (cards.length < REVEAL_N) {
      group = 'general';
      cards = block.querySelectorAll('[data-mq-review][data-trigger="' + group + '"]');
    }
    block.querySelectorAll('[data-mq-review]').forEach((el) => { el.hidden = true; });
    Array.from(cards).slice(0, REVEAL_N).forEach((el) => { el.hidden = false; });
    return { group: group, count: Math.min(REVEAL_N, cards.length) };
  }

  // Item 10 — before/after calendars driven by q5.
  function buildPersonalizedCalendars(answers) {
    const before = ROOT.querySelector('#cal-before');
    const after  = ROOT.querySelector('#cal-after');
    if (!before || !after) return null;
    // Reset for idempotency
    before.innerHTML = ''; before.dataset.built = '';
    after.innerHTML  = ''; after.dataset.built  = '';
    const p = answers.q5_v1 || 'few_per_month';
    const beforeN = _BA_BEFORE_DAYS[p] != null ? _BA_BEFORE_DAYS[p] : 11;
    const afterN  = _BA_AFTER_DAYS[p]  != null ? _BA_AFTER_DAYS[p]  : 3;
    const beforeHits = _BA_BEFORE_POSITIONS.slice(0, beforeN);
    const afterHits  = _BA_AFTER_POSITIONS.slice(0, afterN);
    const sadSvg =
      '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" ' +
      'stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">' +
        '<circle cx="12" cy="12" r="9"/>' +
        '<line x1="9" y1="10" x2="9.01" y2="10"/>' +
        '<line x1="15" y1="10" x2="15.01" y2="10"/>' +
        '<path d="M9 16 Q12 13 15 16"/>' +
      '</svg>';
    const smileSvg =
      '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" ' +
      'stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">' +
        '<circle cx="12" cy="12" r="9"/>' +
        '<line x1="9" y1="10" x2="9.01" y2="10"/>' +
        '<line x1="15" y1="10" x2="15.01" y2="10"/>' +
        '<path d="M8.5 14 Q12 17 15.5 14"/>' +
      '</svg>';
    const fragB = document.createDocumentFragment();
    for (let i = 0; i < 28; i++) {
      const d = document.createElement('div');
      if (beforeHits.indexOf(i) !== -1) { d.className = 'ba-day is-hit-bad'; d.innerHTML = sadSvg; }
      else { d.className = 'ba-day'; }
      fragB.appendChild(d);
    }
    before.appendChild(fragB);
    before.dataset.built = 'true';
    const fragA = document.createDocumentFragment();
    for (let i = 0; i < 28; i++) {
      const d = document.createElement('div');
      if (afterHits.indexOf(i) !== -1) { d.className = 'ba-day is-hit-after'; d.innerHTML = sadSvg; }
      else { d.className = 'ba-day is-good-day'; d.innerHTML = smileSvg; }
      fragA.appendChild(d);
    }
    after.appendChild(fragA);
    after.dataset.built = 'true';

    // Update card-eye counts
    const beforeEye = ROOT.querySelector('[data-mq-ba-before-eye]');
    const afterEye  = ROOT.querySelector('[data-mq-ba-after-eye]');
    if (beforeEye) beforeEye.textContent = 'Before \u00B7 ' + beforeN + ' day' + (beforeN === 1 ? '' : 's');
    if (afterEye)  afterEye.textContent  = 'Day 90 \u00B7 ' + afterN + ' day' + (afterN === 1 ? '' : 's');

    // Summary line
    const sum = ROOT.querySelector('[data-mq-ba-summary]');
    if (sum) {
      sum.innerHTML = 'From <strong>' + beforeN + '</strong> migraine days a month \u2192 <strong>' + afterN +
        '</strong> (estimated, from people with your pattern).';
      sum.hidden = false;
    }
    return { beforeN: beforeN, afterN: afterN };
  }

  // Projection readouts + headline (q5-driven).
  function personalizeProjReadouts(answers) {
    const cfg = _PROJ_READOUT[answers.q5_v1];
    const h2 = ROOT.querySelector('[data-mq-proj-h2]');
    const today = ROOT.querySelector('[data-mq-proj-today]');
    const future = ROOT.querySelector('[data-mq-proj-future]');
    if (cfg) {
      if (h2) {
        // Format: "<lede>. <em>by Day 90.</em>"
        h2.innerHTML = cfg.h2_lede + ' <em>' + cfg.h2_em + '</em>';
      }
      if (today) today.textContent = _cap(cfg.today);
      if (future) future.textContent = _cap(cfg.future);
    }
    return cfg;
  }

  // Item 15 — founder scale paragraph (drives all 3 variants).
  function renderFounderScale(answers) {
    const phrase = _FOUNDER_SCALE_PHRASE[answers.q5_v1];
    const slots = ROOT.querySelectorAll('[data-mq-founder-scale]');
    if (!phrase) {
      slots.forEach((el) => { el.hidden = true; el.textContent = ''; });
      return null;
    }
    const txt = 'When I was getting ' + phrase + ' myself, this is the formula I built.';
    slots.forEach((el) => { el.textContent = txt; el.hidden = false; });
    return txt;
  }

  // Item 16 — hero modifier band.
  function renderModifierBand(routing) {
    const host = ROOT.querySelector('[data-mq-mod-band]');
    if (!host) return null;
    const mods = routing.modifiers || [];
    let chosen = null;
    for (const m of _MOD_BAND_PRIORITY) {
      if (mods.indexOf(m) !== -1) { chosen = m; break; }
    }
    if (!chosen) { host.hidden = true; host.innerHTML = ''; return null; }
    host.innerHTML = _MOD_BAND_COPY[chosen];
    host.hidden = false;
    return chosen;
  }

  // Item 23 — cohort stat line.
  function _cohortBucket(answers) {
    const sex = answers.q1_v1;
    const triggers = answers.q4_v1 || [];
    const pattern = answers.q5_v1;
    const tried = answers.q6_v1 || [];
    if (sex === 'female' && triggers.indexOf('hormonal') !== -1) {
      return { key: 'cycle', label: 'cycle-linked patterns' };
    }
    if (pattern === 'frequent' || pattern === 'constant') {
      return { key: 'chronic', label: 'high-frequency patterns' };
    }
    const RX_T = ['rx_preventive', 'botox', 'triptan'];
    for (const r of RX_T) if (tried.indexOf(r) !== -1) return { key: 'rx', label: 'Rx-paired routines' };
    const STK = ['single_ingredients', 'supplement_formula', 'stacking_5_plus'];
    for (const r of STK) if (tried.indexOf(r) !== -1) return { key: 'stack', label: 'complex stacks' };
    if (pattern === 'new') return { key: 'new_dx', label: 'new diagnoses' };
    return { key: 'default', label: 'your kind of pattern' };
  }
  function renderCohortStat(answers) {
    const host = ROOT.querySelector('[data-mq-cohort-line]');
    if (!host) return null;
    const cohort = _cohortBucket(answers);
    const count = _COHORT_COUNTS[cohort.key] != null ? _COHORT_COUNTS[cohort.key] : _COHORT_COUNTS.default;
    const cEl = host.querySelector('[data-mq-cohort-count]');
    const lEl = host.querySelector('[data-mq-cohort-label]');
    if (cEl) cEl.textContent = count;
    if (lEl) lEl.textContent = cohort.label;
    host.hidden = false;
    return { count: count, label: cohort.label, key: cohort.key };
  }

  // ============================================================
  // Item 25 — debug audit overlay (?debug=1)
  // ============================================================
  let _AUDIT_REPORT = null;
  function renderAuditOverlay() {
    if (!_AUDIT_REPORT) return;
    let panel = document.getElementById('mq-audit-overlay');
    if (!panel) {
      panel = document.createElement('div');
      panel.id = 'mq-audit-overlay';
      panel.setAttribute('style',
        'position:fixed;top:12px;right:12px;width:320px;max-height:90vh;overflow:auto;' +
        'background:rgba(20,15,12,0.92);color:#f7f1e6;font-family:ui-monospace,monospace;' +
        'font-size:11px;line-height:1.45;padding:12px 14px;border-radius:6px;' +
        'z-index:99999;box-shadow:0 6px 24px rgba(0,0,0,0.4);');
      document.body.appendChild(panel);
    }
    const r = _AUDIT_REPORT;
    const lines = [];
    function row(k, v, src) {
      lines.push(
        '<div style="display:flex;gap:6px;padding:2px 0;border-bottom:1px solid rgba(255,255,255,0.06)">' +
          '<div style="color:#f4d99a;flex:0 0 38%;word-break:break-word">' + k + '</div>' +
          '<div style="flex:1;word-break:break-word">' + (v == null || v === '' ? '<em>—</em>' : v) +
          (src ? ' <span style="color:#7a6e5f">(from ' + src + ')</span>' : '') +
          '</div>' +
        '</div>'
      );
    }
    lines.push(
      '<div style="display:flex;justify-content:space-between;align-items:center;margin-bottom:8px">' +
        '<strong style="color:#fff;font-size:12px">QUIZ AUDIT</strong>' +
        '<button id="mq-audit-close" style="background:none;border:1px solid rgba(255,255,255,0.3);color:#fff;cursor:pointer;font:inherit;padding:0 8px;border-radius:3px">x</button>' +
      '</div>'
    );
    row('hero-archetype', r.archetype, 'variant');
    row('hero-name', r.name, 'firstName');
    row('hero-sub', r.heroSub, 'q3+q4+q5+q6+q7');
    row('hero-mod-band', r.modBand, 'modifiers');
    row('psum-pattern', r.psumPattern, 'q5');
    row('psum-triggers', r.psumTriggers, 'q4');
    row('psum-tried', r.psumTried, 'q6');
    row('psum-match-pct', r.matchPct, 'derived');
    row('bb-recap-opener', r.bbRecap, 'q5+q4');
    Object.keys(r.ingTags || {}).forEach((slot) => row('ing-' + slot, r.ingTags[slot], 'rules'));
    row('compare-emphasis', (r.compareEmphasis || []).join(', '), 'compare scoring');
    row('founder-scale', r.founderScale, 'q5');
    row('proj-readout', r.projToday + ' \u2192 ' + r.projFuture, 'q5');
    row('cohort-stat', r.cohortLabel + ' (' + r.cohortCount + ')', r.cohortKey);
    row('reviews-picked', r.reviewsVariant + ' / ' + r.reviewsGroup + ' (' + r.reviewsCount + ')', 'q4+q5');
    panel.innerHTML = lines.join('');
    const close = panel.querySelector('#mq-audit-close');
    if (close) close.addEventListener('click', () => panel.remove(), { once: true });
  }

  // ---------- Result rendering ----------
  function renderResult() {
    const routing = computeRouting(state.answers);
    state.variant = routing.variant;
    state.modifiers = routing.modifiers;

    // Top-level shell: standard result vs not-recommended (safety gate).
    // The standard shell holds the personalized result; the not-recommended
    // shell is a self-contained safety LP with no purchase wiring.
    const standardShell = ROOT.querySelector('[data-shell="standard"]');
    const safetyShell = ROOT.querySelector('[data-shell="not-recommended"]');
    const isSafety = routing.variant === 'not_recommended';
    if (standardShell) standardShell.hidden = isSafety;
    if (safetyShell) safetyShell.hidden = !isSafety;
    if (isSafety) {
      // Hide the sticky purchase bar entirely — there is no offer here.
      const sticky = ROOT.querySelector('[data-mq-sticky]');
      if (sticky) sticky.hidden = true;
      return;  // skip personalization wiring below
    }

    // Reveal variant-conditional blocks
    ROOT.querySelectorAll('[data-show-variant]').forEach((el) => {
      el.hidden = el.getAttribute('data-show-variant') !== routing.variant;
    });
    ROOT.querySelectorAll('[data-show-modifier]').forEach((el) => {
      el.hidden = !routing.modifiers.includes(el.getAttribute('data-show-modifier'));
    });

    // Personalize Section 1
    const archetypeNames = CFG.archetypeNames || {};
    const archetypeEl = ROOT.querySelector('[data-mq-archetype]');
    if (archetypeEl) archetypeEl.textContent = archetypeNames[routing.variant] || 'Your Migraine Profile';

    // Hero h1 stays as the static prototype copy ("[Name,] based on your
    // answers — Mighty® is built…"). Age + pattern live in the receipt chips
    // below, not in the hero — keeps the hero personable instead of clinical.
    fillNameSlots();

    // Stat-token fills — only overwrite the static fallback ("your migraine
    // days" / "your top triggers" / "some things") when we actually have a
    // value. Empty fills would leave the hero subtitle reading
    // "You're getting , mostly set off by ." which looks broken on the
    // skip-to-results path with no answers.
    const _statPattern = _humanPattern(state.answers.q5_v1);
    const _statTriggers = _humanList(state.answers.q4_v1, _TRIGGER_PHRASE, 3);
    const _statTried = _humanList(state.answers.q6_v1, _TRIED_PHRASE, 3);
    if (_statPattern) fillStat('[data-mq-stat-pattern]', _statPattern);
    if (_statTriggers) fillStat('[data-mq-stat-triggers]', _statTriggers);
    if (_statTried) fillStat('[data-mq-stat-tried]', _statTried);

    // Personalize Section 3
    fillText('[data-mq-symptoms-list]', _humanList(state.answers.q3_v1, _SYMPTOM_PHRASE, 3));
    fillText('[data-mq-triggers-list]', _humanList(state.answers.q4_v1, _TRIGGER_PHRASE, 3));
    fillText('[data-mq-pattern-label]', _humanPattern(state.answers.q5_v1) || 'common');
    fillText('[data-mq-tried-list]', _humanList(state.answers.q6_v1, _TRIED_PHRASE, 3) || 'nothing yet');
    fillText('[data-mq-match-pct]', _matchPct(state.answers, routing) + '%');

    personalizeIngredientTags(state.answers);
    personalizeBuyBoxRecap(state.answers, routing);

    // Personalize Section 4 plan steps
    // (Layer bodies are now static Mighty-mechanism copy — no JS override.
    // Earlier the bodies were filled with generic trigger/pattern lifestyle
    // advice, which fought against the mechanism each layer is supposed to
    // explain. The static copy is sharper and on-message.)

    // ---------- Personalization ----------
    renderHeroSub(state.answers);
    const _modBand = renderModifierBand(routing);
    const _compareEmphasis = personalizeCompareEmphasis(state.answers);
    const _founderScale = renderFounderScale(state.answers);
    const _cohort = renderCohortStat(state.answers);
    personalizeProjReadouts(state.answers);
    const _reviews = pickReviews(state.answers, routing.variant);

    // CTA href
    const cartUrl = buildCartUrl(routing);
    // Only the buy-box "Add to cart" CTA (id="cta-main") routes to checkout.
    // Other CTAs (sticky bar, psum recap) keep href="#offer" so they smooth-
    // scroll to the buy box — letting the user pick a plan before committing.
    ROOT.querySelectorAll('[data-mq-cta-button]').forEach((a) => {
      if (a.id === 'cta-main') a.setAttribute('href', cartUrl);
    });
    // Bind smooth-scroll on in-page anchor CTAs + capture every CTA click.
    ROOT.querySelectorAll('a[data-mq-cta-button]').forEach((a) => {
      if (a.dataset.mqScrollBound === 'true') return;
      a.dataset.mqScrollBound = 'true';
      a.addEventListener('click', (ev) => {
        const href = a.getAttribute('href') || '';
        _capture('quiz_cta_clicked', {
          cta_id: a.id || '',
          cta_location: a.dataset.mqCtaLocation || a.id || 'unknown',
          target: href,
          route_variant: routing.variant,
        });
        if (href.startsWith('#') && href.length > 1) {
          const target = document.querySelector(href);
          if (target) {
            ev.preventDefault();
            target.scrollIntoView({ behavior: 'smooth', block: 'start' });
            // Highlight the recommended plan briefly so user sees where to go.
            const recommended = target.querySelector('.bb-plan.is-selected') || target.querySelector('.bb-plan');
            if (recommended) {
              recommended.style.boxShadow = '0 0 0 3px var(--m-red, #d9372a)';
              setTimeout(() => { recommended.style.boxShadow = ''; }, 1400);
            }
          }
        }
      });
    });

    // History — make page reloadable + shareable. URL is `?r=<opaque token>`
    // only; never carries answer keys or condition signals (Meta classifier
    // reads URL parameter NAMES and VALUES on `page_viewed`). Use a relative
    // URL so we stay on whichever path the page was loaded at — only the
    // Klaviyo `quiz_result_permalink` property gets the hardcoded canonical
    // URL (see RESULT_PAGE_URL).
    if (state.resultToken) {
      history.replaceState(null, '', '?r=' + encodeURIComponent(state.resultToken));
    } else {
      // Skip-to-results path or token build failed — still strip any inbound
      // query string so we don't accidentally leave leaky URL state behind.
      history.replaceState(null, '', location.pathname);
    }

    // Save completion
    try { localStorage.setItem(LS_COMPLETED, JSON.stringify({ ts: Date.now(), variant: routing.variant, modifiers: routing.modifiers })); } catch (e) {}

    // Sticky CTA scroll listener + FAQ toggles
    bindStickyScroll();
    bindFaqToggles();

    // Prototype LP behaviors — only meaningful when standard shell shown.
    // Each is idempotent / no-ops when host elements are missing.
    bindHeroQuoteCarousel();
    bindBuyBoxGallery(routing);
    // Item 10 — calendar driven by q5 (replaces buildCalendars()).
    buildPersonalizedCalendars(state.answers);
    bindModals();

    // Meta Pixel + GA4 — funnel attribution. ViewContent fires once when
    // #offer crosses 50% of viewport; AddToCart fires on #cta-main click.
    // Bound here (not in boot) so the not_recommended/safety branch's early
    // `return` above keeps these from firing for pregnancy-routed users.
    _bindViewContent();
    _bindAddToCart();

    // Item 25 — debug audit overlay. Capture report after all renders ran.
    const ingTags = {};
    ROOT.querySelectorAll('[data-mq-ing-tag]').forEach((el) => {
      ingTags[el.getAttribute('data-mq-ing-tag')] = el.textContent;
    });
    const archetypeName = (CFG.archetypeNames || {})[routing.variant] || 'Your Migraine Profile';
    const heroSubEl = ROOT.querySelector('[data-mq-hero-sub]');
    const bbRecapEl = ROOT.querySelector('[data-mq-bb-recap-opener]');
    const projTodayEl = ROOT.querySelector('[data-mq-proj-today]');
    const projFutureEl = ROOT.querySelector('[data-mq-proj-future]');
    _AUDIT_REPORT = {
      archetype: archetypeName + ' [' + routing.variant + ']',
      name: state.firstName || '(none)',
      heroSub: heroSubEl ? heroSubEl.textContent : '',
      modBand: _modBand || '(none)',
      psumPattern: _humanPattern(state.answers.q5_v1),
      psumTriggers: _humanList(state.answers.q4_v1, _TRIGGER_PHRASE, 3),
      psumTried: _humanList(state.answers.q6_v1, _TRIED_PHRASE, 3),
      matchPct: _matchPct(state.answers, routing) + '%',
      bbRecap: bbRecapEl ? bbRecapEl.textContent : '',
      ingTags: ingTags,
      compareEmphasis: _compareEmphasis,
      founderScale: _founderScale || '(none — q5 missing)',
      projToday: projTodayEl ? projTodayEl.textContent : '',
      projFuture: projFutureEl ? projFutureEl.textContent : '',
      cohortLabel: _cohort ? _cohort.label : '',
      cohortCount: _cohort ? _cohort.count : '',
      cohortKey: _cohort ? _cohort.key : '',
      reviewsVariant: routing.variant,
      reviewsGroup: _reviews.group,
      reviewsCount: _reviews.count,
    };
    try {
      if (new URLSearchParams(location.search).get('debug') === '1') {
        renderAuditOverlay();
      }
    } catch (e) { /* ignore */ }
  }

  // ---------- Prototype LP: hero-quote auto-scroll carousel ----------
  function bindHeroQuoteCarousel() {
    const track = ROOT.querySelector('#hero-quote-track');
    const dots = ROOT.querySelectorAll('#hero-quote-dots .hero-quote-dot');
    if (!track || !dots.length) return;
    if (track.dataset.bound === 'true') return;
    track.dataset.bound = 'true';

    const total = dots.length;
    let i = 0;
    let timer = null;

    function go(n) {
      i = (n + total) % total;
      track.style.transform = 'translateX(-' + (i * 100) + '%)';
      dots.forEach((d, j) => d.classList.toggle('is-active', j === i));
    }
    function start() {
      stop();
      timer = setInterval(() => go(i + 1), 6000);
    }
    function stop() { if (timer) { clearInterval(timer); timer = null; } }

    dots.forEach((d, j) => d.addEventListener('click', () => { go(j); start(); }));
    track.addEventListener('mouseenter', stop);
    track.addEventListener('mouseleave', start);
    // On mobile, touchstart was pausing the carousel permanently because
    // there's no mouseleave to restart it. Pause briefly on touchstart, then
    // resume so auto-rotation continues after the user's tap.
    track.addEventListener('touchstart', () => { stop(); setTimeout(start, 4000); }, { passive: true });
    start();
  }

  // ---------- Prototype LP: BuyBox gallery + plan price math ----------
  function bindBuyBoxGallery(routing) {
    const track = ROOT.querySelector('#bb-track');
    const dotsHost = ROOT.querySelector('#bb-dots');
    const thumbs = ROOT.querySelectorAll('.bb-thumb');
    const slides = track ? track.querySelectorAll('.bb-slide') : [];
    if (track && track.dataset.bound !== 'true') {
      track.dataset.bound = 'true';

      if (dotsHost && slides.length && !dotsHost.children.length) {
        slides.forEach((_, i) => {
          const d = document.createElement('span');
          d.className = 'bb-dot' + (i === 0 ? ' is-active' : '');
          dotsHost.appendChild(d);
        });
      }
      const dots = dotsHost ? dotsHost.querySelectorAll('.bb-dot') : [];

      function setActive(i) {
        dots.forEach((d, j) => d.classList.toggle('is-active', i === j));
        thumbs.forEach((t, j) => t.classList.toggle('is-active', i === j));
      }
      let raf = 0;
      track.addEventListener('scroll', () => {
        cancelAnimationFrame(raf);
        raf = requestAnimationFrame(() => {
          const w = track.clientWidth;
          const i = Math.round(track.scrollLeft / w);
          setActive(i);
        });
      }, { passive: true });

      thumbs.forEach((t) => {
        t.addEventListener('click', () => {
          const i = parseInt(t.dataset.i, 10);
          const slide = slides[i];
          if (slide && track) track.scrollTo({ left: slide.offsetLeft, behavior: 'smooth' });
        });
      });
    }

    // Plan selection + price math (idempotent — listeners cheap, dedup with dataset flag)
    // Sub-50%-first-month offer (2026-07-19), copied from the 7-ways listicle:
    // 30-day sub at $39 first month (50% off $79 via MIGHTY50 + FREE-SHIPPING),
    // one-time at $79 list (+ shipping at checkout). No gifts, no 90-day plan.
    const PLANS = {
      '30':   { per: 39, qty: 1, was: 79, cadence: 'Ships every 4 weeks' },
      'once': { per: 79, qty: 1, was: null, cadence: 'One-time delivery' },
    };
    // Plan-specific cart permalinks. Inner `&` is `%26` so Shopify's `cart/clear?return_to=`
    // wrapper doesn't split the inner querystring at the first ampersand.
    // Same URLs as the 7-ways listicle plan cards (2026-07-19): 30 = 30-Day
    // Supply 48982660284736 on selling plan 692903412032 with
    // discount=MIGHTY50,FREE-SHIPPING ($39 first month); once = 30-Day Supply
    // one-time, no discount ($79 + shipping at checkout).
    const CART_URLS = {
      '30':   'https://joinmelina.com/cart/clear?return_to=/cart/add?items[0][id]=48982660284736%26items[0][quantity]=1%26items[0][selling_plan]=692903412032%26return_to=/checkout?discount=MIGHTY50,FREE-SHIPPING',
      'once': 'https://joinmelina.com/cart/clear?return_to=/cart/add?items[0][id]=48982660284736%26items[0][quantity]=1%26return_to=/checkout',
    };
    const fmt = (n) => '$' + n;
    // Cart attributes → Shopify order note_attributes. Appended to the inner
    // /cart/add querystring (%26-separated), so the attributes survive the
    // cart/clear→return_to redirect and land on the order — this is what makes
    // buy-box purchases segmentable by offer/quiz in Shopify. Without it the
    // hardcoded CART_URLS ship ZERO attribution (the buildCartUrl template's
    // attributes never reach checkout: selectPlan overwrites #cta-main).
    function cartAttrsSuffix(planId) {
      const attrs = {
        'offer': CFG.offerVersion || '',
        'quiz_plan': planId || '',
        'utm_source': 'quiz',
        'utm_medium': 'result-page',
        'utm_campaign': CFG.quizId,
        'quiz_route': (routing && routing.variant) || '',
        'quiz_modifiers': (routing && (routing.modifiers || []).join(',')) || '',
      };
      return Object.keys(attrs)
        .filter((k) => attrs[k] !== '')
        .map((k) => '%26attributes[' + k + ']=' + encodeURIComponent(attrs[k]))
        .join('');
    }
    function selectPlan(planId) {
      const plan = PLANS[planId];
      if (!plan) return;
      _capture('quiz_plan_selected', { plan: planId });
      ROOT.querySelectorAll('.bb-plan').forEach(el => {
        el.classList.toggle('is-selected', el.dataset.plan === planId);
      });
      const total = plan.total != null ? plan.total : plan.per * plan.qty;
      const wasTotal = plan.wasTotal != null
        ? plan.wasTotal
        : (plan.was ? plan.was * plan.qty : null);
      const savings = wasTotal ? wasTotal - total : 0;
      const amountEl = ROOT.querySelector('#bb-cta-amount');
      if (amountEl) amountEl.textContent = fmt(total);
      const ctaWasEl = ROOT.querySelector('#bb-cta-was');
      if (ctaWasEl) {
        if (wasTotal && savings > 0) {
          ctaWasEl.style.display = '';
          ctaWasEl.textContent = fmt(wasTotal);
        } else {
          ctaWasEl.style.display = 'none';
        }
      }
      const ctaMain = ROOT.querySelector('#cta-main');
      if (ctaMain && CART_URLS[planId]) {
        ctaMain.setAttribute('href', CART_URLS[planId] + cartAttrsSuffix(planId));
      }
    }
    ROOT.querySelectorAll('.bb-plan').forEach(el => {
      if (el.dataset.bound === 'true') return;
      el.dataset.bound = 'true';
      el.addEventListener('click', (e) => {
        e.preventDefault();
        selectPlan(el.dataset.plan);
      });
    });
    selectPlan('30');
  }

  // ---------- Prototype LP: Before/after calendar tile generation ----------
  function buildCalendars() {
    const before = [1,3,4,8,11,14,17,18,22,24,26];
    const after  = [5,12,21];
    const sadSvg =
      '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" ' +
      'stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">' +
        '<circle cx="12" cy="12" r="9"/>' +
        '<line x1="9" y1="10" x2="9.01" y2="10"/>' +
        '<line x1="15" y1="10" x2="15.01" y2="10"/>' +
        '<path d="M9 16 Q12 13 15 16"/>' +
      '</svg>';
    const smileSvg =
      '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" ' +
      'stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">' +
        '<circle cx="12" cy="12" r="9"/>' +
        '<line x1="9" y1="10" x2="9.01" y2="10"/>' +
        '<line x1="15" y1="10" x2="15.01" y2="10"/>' +
        '<path d="M8.5 14 Q12 17 15.5 14"/>' +
      '</svg>';
    function buildBefore(host, hits) {
      if (!host || host.dataset.built === 'true') return;
      host.dataset.built = 'true';
      const frag = document.createDocumentFragment();
      for (let i = 0; i < 28; i++) {
        const d = document.createElement('div');
        if (hits.includes(i)) { d.className = 'ba-day is-hit-bad'; d.innerHTML = sadSvg; }
        else { d.className = 'ba-day'; }
        frag.appendChild(d);
      }
      host.appendChild(frag);
    }
    function buildAfter(host, hits) {
      if (!host || host.dataset.built === 'true') return;
      host.dataset.built = 'true';
      const frag = document.createDocumentFragment();
      for (let i = 0; i < 28; i++) {
        const d = document.createElement('div');
        if (hits.includes(i)) { d.className = 'ba-day is-hit-after'; d.innerHTML = sadSvg; }
        else { d.className = 'ba-day is-good-day'; d.innerHTML = smileSvg; }
        frag.appendChild(d);
      }
      host.appendChild(frag);
    }
    buildBefore(ROOT.querySelector('#cal-before'), before);
    buildAfter(ROOT.querySelector('#cal-after'),  after);
  }

  // ---------- Prototype LP: modal system (ingredients panel + CoA) ----------
  // Lazy-load Judge.me reviews into the review-wall modal on first open.
  // Walks every page of Judge.me's public widget endpoint and concatenates
  // the review markup so the modal shows ALL matching reviews (no pagination
  // UI). Page 1 fetched first to learn the total count; the rest fire in
  // parallel. Session-cached — re-opening the modal does not refetch.
  const _JDGM_PER_PAGE = 50;        // Judge.me caps per_page server-side
  const _JDGM_PAGE_LIMIT = 60;      // safety: hard cap at ~3000 reviews
  // Pagination chrome we always strip — looks random/broken when every
  // review is rendered inline.
  const _JDGM_PAGINATE_SELECTORS = [
    '.jdgm-paginate', '.jdgm-paginate__page', '.jdgm-curt',
    '.jdgm-rev-widg__paginate', '.jdgm-paginate-curt',
    '.jdgm-rev-widg__paginate-spinner',
  ].join(',');

  function _stripJdgmPagination(root) {
    root.querySelectorAll(_JDGM_PAGINATE_SELECTORS).forEach((el) => el.remove());
  }
  function _normalizeJdgmUrl(url) {
    // Strip any inbound per_page / page so we control them ourselves.
    return url.replace(/([?&])(per_page|page)=[^&]*&?/g, '$1').replace(/[?&]$/, '');
  }
  async function _fetchJdgmPage(baseUrl, page) {
    const sep = baseUrl.includes('?') ? '&' : '?';
    const u = baseUrl + sep + 'per_page=' + _JDGM_PER_PAGE + '&page=' + page;
    const res = await fetch(u, { credentials: 'omit' });
    return res.json();
  }
  function _parseJdgmHtml(htmlString) {
    const tmp = document.createElement('div');
    tmp.innerHTML = htmlString || '';
    _stripJdgmPagination(tmp);
    return tmp;
  }

  let _reviewsLoaded = false;
  async function loadReviewsOnce() {
    if (_reviewsLoaded) return;
    _reviewsLoaded = true;
    const host = ROOT.querySelector('[data-mq-reviews-fetch]');
    if (!host) return;
    const rawUrl = host.dataset.jdgmUrl;
    if (!rawUrl) return;
    const baseUrl = _normalizeJdgmUrl(rawUrl);
    host.innerHTML = '<p class="rw-empty">Loading reviews…</p>';
    try {
      // Page 1 — learn total_count, render the wrapper.
      const first = await _fetchJdgmPage(baseUrl, 1);
      const firstTmp = _parseJdgmHtml(first && first.html);
      const firstCards = firstTmp.querySelectorAll('.jdgm-rev');
      if (firstCards.length === 0) {
        host.innerHTML = '<p class="rw-empty">Reviews are temporarily unavailable.</p>';
        return;
      }
      // Mount page 1 (full widget wrapper) into the host.
      host.innerHTML = '';
      while (firstTmp.firstChild) host.appendChild(firstTmp.firstChild);
      // Find where to append subsequent pages' review cards. Prefer
      // .jdgm-rev-widg__reviews (the flex container with gap: 14px) so
      // appended cards inherit the same vertical spacing as page-1 cards;
      // fall back to __body or the host if Judge.me's markup changes.
      const reviewBody = host.querySelector('.jdgm-rev-widg__reviews')
        || host.querySelector('.jdgm-rev-widg__body')
        || host;
      // Compute how many more pages exist. Judge.me returns total/total_count
      // depending on revision; fall back to "fetch until empty" if neither
      // is present.
      const total = first.total != null ? first.total
                  : (first.total_count != null ? first.total_count : null);
      let totalPages;
      if (total != null) {
        totalPages = Math.min(Math.ceil(total / _JDGM_PER_PAGE), _JDGM_PAGE_LIMIT);
      } else {
        // No total — walk serially until a page returns < PER_PAGE.
        let p = 2;
        while (p <= _JDGM_PAGE_LIMIT) {
          const data = await _fetchJdgmPage(baseUrl, p);
          const tmp = _parseJdgmHtml(data && data.html);
          const cards = tmp.querySelectorAll('.jdgm-rev');
          cards.forEach((c) => reviewBody.appendChild(c));
          if (cards.length < _JDGM_PER_PAGE) break;
          p += 1;
        }
        // Belt-and-suspenders: re-strip in case any wrapper smuggled
        // pagination markup back in.
        _stripJdgmPagination(host);
        return;
      }
      // We know totalPages — fetch 2..N in parallel and append in order.
      if (totalPages > 1) {
        const pages = [];
        for (let p = 2; p <= totalPages; p++) pages.push(p);
        const results = await Promise.all(pages.map((p) => _fetchJdgmPage(baseUrl, p)));
        results.forEach((data) => {
          const tmp = _parseJdgmHtml(data && data.html);
          tmp.querySelectorAll('.jdgm-rev').forEach((c) => reviewBody.appendChild(c));
        });
      }
      _stripJdgmPagination(host);
    } catch (e) {
      _reviewsLoaded = false;  // allow retry on next open
      host.innerHTML = '<p class="rw-empty">Reviews are temporarily unavailable.</p>';
    }
  }

  function bindModals() {
    function openModal(id) {
      const el = ROOT.querySelector('#' + id);
      if (!el) return;
      el.classList.add('is-open');
      document.body.style.overflow = 'hidden';
      if (id === 'modal-reviews') loadReviewsOnce();
      _capture('quiz_modal_opened', { modal_id: id });
    }
    function closeModal(el) {
      el.classList.remove('is-open');
      document.body.style.overflow = '';
    }
    ROOT.querySelectorAll('[data-modal]').forEach(t => {
      if (t.dataset.bound === 'true') return;
      t.dataset.bound = 'true';
      t.addEventListener('click', (e) => { e.preventDefault(); openModal(t.dataset.modal); });
    });
    ROOT.querySelectorAll('.modal-overlay').forEach(overlay => {
      if (overlay.dataset.bound === 'true') return;
      overlay.dataset.bound = 'true';
      overlay.addEventListener('click', (e) => {
        if (e.target === overlay || e.target.hasAttribute('data-close')) closeModal(overlay);
      });
    });
    if (!ROOT.dataset.modalsKeyBound) {
      ROOT.dataset.modalsKeyBound = 'true';
      document.addEventListener('keydown', (e) => {
        if (e.key === 'Escape') {
          ROOT.querySelectorAll('.modal-overlay.is-open').forEach(closeModal);
        }
      });
    }
  }

  function fillText(sel, txt) {
    // Fill ALL matching elements — the same hook (e.g. data-mq-triggers-list)
    // is reused across the why-body, hero, and psum-recap sections. Using
    // querySelector left the duplicates rendering as "—".
    // Sentence-case the value when the host element is a recap-card cell
    // (.psum-cell-val) or a projection readout (.proj-readout-val); both are
    // standalone visual values that read awkwardly when lowercase. Mid-
    // sentence usages of the same hook (e.g. <strong> inside why-body) keep
    // the original lowercase phrase.
    ROOT.querySelectorAll(sel).forEach((el) => {
      const cap = el.classList.contains('psum-cell-val') || el.classList.contains('proj-readout-val');
      el.textContent = cap ? _cap(txt) : txt;
    });
  }
  function fillStat(sel, txt) {
    ROOT.querySelectorAll(sel).forEach((el) => { el.textContent = txt; });
  }

  function fillNameSlots() {
    // First-name salutation across the result page (hero, founder, bb-recap,
    // psum). Each slot carries data-name-fallback (no name) and data-name-with
    // (with name, "{name}" placeholder). When state.firstName is empty (skip-
    // to-results path or user left it blank), the static fallback stands.
    const name = (state.firstName || '').trim();
    ROOT.querySelectorAll('[data-mq-name-slot]').forEach((el) => {
      const tpl = name ? el.getAttribute('data-name-with') : el.getAttribute('data-name-fallback');
      if (tpl == null) return;
      el.textContent = tpl.replace('{name}', _escapeName(name));
    });
  }
  function _escapeName(s) {
    // First names only — strip control chars and cap at 24 chars to avoid
    // someone pasting a paragraph into the email gate's first-name field.
    return (s || '').replace(/[\u0000-\u001f]/g, '').slice(0, 24);
  }
  function buildCartUrl(routing) {
    const tpl = CFG.cartPermalinkTemplate || '';
    return tpl
      .replace(/\{variant_id\}/g, encodeURIComponent(CFG.shopifyVariantId))
      .replace(/\{quiz_id\}/g,    encodeURIComponent(CFG.quizId))
      .replace(/\{offer_version\}/g, encodeURIComponent(CFG.offerVersion || ''))
      .replace(/\{variant\}/g,    encodeURIComponent(routing.variant))
      .replace(/\{modifiers\}/g,  encodeURIComponent((routing.modifiers || []).join(',')));
  }

  // ---------- Sticky CTA + FAQ ----------

  function bindStickyScroll() {
    const sticky = ROOT.querySelector('[data-mq-sticky]');
    const why = ROOT.querySelector('#mq-r-why');
    if (!sticky || !why) return;
    const bb = ROOT.querySelector('#offer');
    function onScroll() {
      const rect = why.getBoundingClientRect();
      const past = rect.top < window.innerHeight * 0.5;
      let bbVisible = false;
      if (bb) {
        const bbRect = bb.getBoundingClientRect();
        bbVisible = bbRect.top < window.innerHeight && bbRect.bottom > 0;
      }
      sticky.hidden = !past || bbVisible;
    }
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }

  function bindFaqToggles() {
    ROOT.querySelectorAll('.mq__r-qa').forEach((qa) => {
      const q = qa.querySelector('.mq__r-q');
      const a = qa.querySelector('.mq__r-a');
      const ic = qa.querySelector('.mq__r-q-ic');
      if (!q || !a || !ic) return;
      a.style.display = a.style.display || 'block';   // first open
      q.addEventListener('click', () => {
        const open = a.style.display !== 'none';
        a.style.display = open ? 'none' : 'block';
        ic.textContent = open ? '+' : '−';
      });
    });
  }

  // ---------- Boot ----------
  async function boot() {
    // Splice presentational cards into the navigation order:
    //   - intro_splash at index 0 (the "what you get" preview screen)
    //   - interstitial_pulse after q4_v1 (Mighty) or the cycle question (EB)
    // Both kept out of the YAML / renderer so they stay presentational only.
    if (Array.isArray(CFG.questionIds)) {
      var introEl = ROOT.querySelector('[data-question-id="intro_splash"]');
      if (introEl && CFG.questionIds.indexOf('intro_splash') === -1) {
        CFG.questionIds.unshift('intro_splash');
      }
      // EB has its own phase-keyed interstitial after the cycle question;
      // Mighty has the multi-select symptom/trigger interstitial after q4_v1.
      // Splice 'interstitial_pulse' after the appropriate ID so
      // navigation/progress treats it as a slide.
      if (CFG.questionIds.indexOf('interstitial_pulse') === -1) {
        const ebV2 = _isEverbrightQuiz();
        const q4Id = ebV2 ? 'cycle' : 'q4_v1';
        const at = CFG.questionIds.indexOf(q4Id);
        if (at !== -1) CFG.questionIds.splice(at + 1, 0, 'interstitial_pulse');
      }
      // mighty-dizzy-v1: six DOM-only interstitials, each spliced after its
      // anchor. int_meet anchors on int_mechanism and int_timeline on
      // int_studies (each spliced just before), so order in this list
      // matters. int_studies is conditionally skipped at navigation time via
      // _shouldSkipQuestion (q8_studies !== 'very').
      // int_validate ("You're not alone") removed 2026-07-25: 53% of q1
      // answerers abandoned on that screen (62 viewed → 29 continued).
      if (_isDizzyQuiz()) {
        [['q4_cutback', 'int_mechanism'],
         ['int_mechanism', 'int_meet'],
         ['q6_support', 'int_wholebody'],
         ['q7_tried', 'int_gap'],
         ['q8_studies', 'int_studies'],
         ['int_studies', 'int_timeline']].forEach(function (pair) {
          var at2 = CFG.questionIds.indexOf(pair[0]);
          if (at2 !== -1 && CFG.questionIds.indexOf(pair[1]) === -1) {
            CFG.questionIds.splice(at2 + 1, 0, pair[1]);
          }
        });
      }
    }
    loadSession();
    const params = new URLSearchParams(location.search);
    var utCode = params.get('ut');
    if (utCode && _UT_LABELS[utCode]) {
      var hEl = ROOT.querySelector('.mq__hero-q1-headline');
      if (hEl) hEl.innerHTML = 'Tired of guessing what sets off <em>your</em> ' + _UT_LABELS[utCode] + ' migraine?';
    }
    const r = params.get('r');
    if (r && !_isDizzyQuiz()) {
      // Inbound from result-email CTA — decrypt the token, hydrate state,
      // jump straight to the result page. Bad/stale tokens fall through to
      // a fresh quiz; the strip below removes the offending param so the
      // user can't accidentally re-share a broken link.
      const decoded = await decodeResultToken(r);
      if (decoded) {
        state.answers = decoded.a || {};
        state.variant = decoded.v;
        state.modifiers = decoded.m || [];
        state.resultToken = r;
        const routing = computeRouting(state.answers);
        _capture('quiz_inbound_from_email', {
          route_variant: routing.variant,
          archetype: routing.variant,
        });
        state.stage = 'loading';
        revealResult();
        bindQuizHandlers();   // still bind in case user navigates back
        bindEmailHandlers();
        return;
      }
      // Decode failed — quiz_token_rejected was already captured inside
      // decodeResultToken. Strip the bad token so the URL no longer encodes
      // a state we couldn't honor, then fall through to a clean quiz start.
      history.replaceState({}, '', location.pathname);
    }
    // First-render = a brand-new quiz session. Resumption from sessionStorage
    // (mid-quiz refresh) shouldn't double-fire — that's a continuation.
    if ((state.cursor || 0) === 0 && Object.keys(state.answers || {}).length === 0) {
      _capture('quiz_started', { ut: utCode || '' });
      if (_isEverbrightQuiz()) {
        const _ebEid = _pixelMkEventId('eb-start');
        _fb('trackCustom', 'EB_QuizStart', { quiz_id: MQ_CONFIG.quizId, event_id: _ebEid }, { eventID: _ebEid });
      }
    }
    setStage('quiz');
    showQuestion(state.cursor || 0);
    bindQuizHandlers();
    bindEmailHandlers();
    flushEmailQueue();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => { boot().catch(() => {}); });
  } else {
    boot().catch(() => {});
  }

  // Expose for Tasks 9-17 to attach handlers.
  window.MQ = {
    state, setStage, showQuestion, advance, saveSession,
    runLoadingThenReveal, revealResult,
    computeRouting, renderResult, bindStickyScroll,
    renderModifierBand, personalizeCompareEmphasis,
    renderFounderScale, renderCohortStat,
    personalizeProjReadouts, buildPersonalizedCalendars, pickReviews,
    renderAuditOverlay,
  };
})();
